import { Gi3DGlasses, GiBowieKnife, GiBunkBeds, GiC96, GiCannon, GiChaingun, GiColtM1911, GiForkKnifeSpoon, GiHandcuffs, GiHastyGrave, GiHeadphones, GiHealing, GiHealingShield, GiHealthCapsule, GiHealthDecrease, GiHealthIncrease, GiHealthNormal, GiHealthPotion, GiHeartBattery, GiHeartBeats, GiHeartDrop, GiHeartOrgan, GiHeartPlus, GiHearts, GiHeavyBullets, GiHeavyRain, GiHelicopter, GiHexagonalNut, GiHiking, GiKnifeFork, GiLargePaintBrush, GiLightningArc, GiLuger, GiMachineGun, GiMachineGunMagazine, GiMinigun, GiOfficeChair, GiPersonInBed, GiPillow, GiPirateCannon, GiPistolGun, GiScorpion, GiShotgunRounds, GiSwissArmyKnife, GiTrenchKnife, GiUnicorn } from "react-icons/gi";


import { AiFillSetting, AiFillStar, AiOutlineMenu, AiOutlineMinus, AiOutlinePlus, AiOutlineQuestionCircle, AiOutlineSearch, AiOutlineStar } from 'react-icons/ai';
import { TbTypography } from 'react-icons/tb';
import { Bs123, BsCalendarDate, BsChevronDown, BsChevronLeft, BsChevronRight, BsChevronUp, BsTextWrap, BsClock, BsLink45Deg, BsChevronCompactRight, BsCheckCircle, BsCheckCircleFill, BsBan, BsPersonFill, Bs0Circle, Bs1Circle, Bs2Circle, Bs3Circle, Bs4Circle, Bs5Circle, Bs6Circle, Bs7Circle, Bs8Circle, Bs9Circle, BsActivity, BsAirplane, BsAlarm, BsAlphabet, BsAlphabetUppercase, BsApp, BsArchive, BsArrowDownUp, BsArrowLeftRight, BsArrowThroughHeart, BsAsterisk, BsAt, BsAward, BsBackpack, BsBackspace, BsBag, BsBalloon, BsBandaid, BsBank, BsBarChart, BsBarChartSteps, BsBasket2, BsBattery, BsBell, BsBinoculars, BsBodyText, BsBook, BsBookmark, BsBoombox, BsBox, BsBoxSeam, BsBraces, BsBracesAsterisk, BsBricks, BsBriefcase, BsBrush, BsBucket, BsBug, BsBuilding, BsBuildings, BsBullseye, BsBusFrontFill, BsCake, BsCalculator, BsCameraReels, BsCamera, BsCapsule, BsCardChecklist, BsCardText, BsCart3, BsCash, BsChat, BsCheck2, BsCheck2Square, BsCloud, BsCode, BsCodeSlash, BsCommand, BsCompass, BsCone, BsController, BsCpu, BsCreditCard, BsCrosshair, BsCup, BsDatabase, BsDroplet, BsEar, BsEnvelope, BsExclamationCircle, BsEye, BsEyeglasses, BsFileEarmark, BsFilm, BsFingerprint, BsFire, BsFlag, BsFloppy, BsFlower1, BsFolder, BsFuelPump, BsFunnel, BsGear, BsGem, BsGenderFemale, BsGenderMale, BsGeoAlt, BsGift, BsGlobe, BsGlobeAmericas, BsGraphUp, BsHammer, BsHandIndexThumb, BsHandThumbsDown, BsHandThumbsUp, BsHeart, BsHeartPulse, BsHourglass, BsHouse, BsImage, BsInbox, BsInfinity, BsJournal, BsJoystick, BsKey, BsKeyboard, BsLifePreserver, BsLightbulb, BsLightningCharge, BsListUl, BsLock, BsCapsulePill, BsClipboard2Pulse, BsHospital, BsLamp, BsPersonStanding, BsPersonWalking, BsPersonWheelchair, BsPrescription, BsRocketTakeoff, BsScissors, BsSearch, BsSliders, BsTag, BsThreeDotsVertical, BsWifi, BsWrench, BsYinYang, BsFillPlusSquareFill, BsSpeedometer2, BsThermometerHalf, BsPaperclip, BsDownload, BsUpload, BsFiletypePdf, BsFiletypeDoc, BsFiletypeDocx, BsFiletypeXls, BsFiletypeXlsx, BsFiletypeCsv, BsFiletypePpt, BsFiletypePptx, BsFiletypeTxt, BsFiletypeMd, BsFileEarmarkZip, BsFileEarmarkImage, BsFileRichtext, BsRulers, BsCollection, BsTypeBold, BsTypeItalic, BsTypeStrikethrough, BsTypeH1, BsTypeH2, BsTypeH3, BsListOl, BsMarkdown, BsBoxArrowUpRight, BsPencilSquare, BsCopy, BsDiagram3, BsTrash3, BsInfoCircle, BsClockHistory, BsToggleOn, } from 'react-icons/bs';
import { MdClose, MdDirectionsCar, MdOutlineAccessible, MdOutlineAssistWalker, MdOutlineBathtub, MdOutlineBoy, MdOutlineChair, MdOutlineElderly, MdOutlineElderlyWoman, MdOutlineGirl, MdOutlineHome, MdOutlineMedicalServices, MdOutlineMonitorHeart, MdOutlineSchool, MdOutlineShower, MdOutlineVaccines, MdSportsFootball, MdKeyboardBackspace, MdAdminPanelSettings, } from 'react-icons/md';
import { TbArmchair, TbBed, TbBedFlat, TbCane, TbCrutches, TbDog, TbEmergencyBed, TbNurse, TbPills, TbSelect, TbSofa, TbStethoscope, TbUfo, TbCalendarTime, TbSortAscendingLetters, TbSortDescendingLetters, TbGauge, } from 'react-icons/tb';
import { RxDragHandleDots2, RxIdCard } from 'react-icons/rx';
import { LuRefreshCw, LuRockingChair, } from 'react-icons/lu';
import { PiToilet, } from 'react-icons/pi';
import { IoColorPaletteOutline, IoDocumentOutline, } from 'react-icons/io5';
import { TbBorderNone } from 'react-icons/tb';
import { TfiSave } from 'react-icons/tfi';
import { AppstoreOutlined, ShareAltOutlined } from '@ant-design/icons';

// Expanded user-selectable library (see the USER SELECTABLE — LIBRARY section below).
import { Bs0Square, Bs1Square, Bs2Square, Bs3Square, Bs4Square, Bs5Square, Bs6Square, Bs7Square, Bs8Square, Bs9Square, BsAlt, BsAmazon, BsAndroid2, BsApple, BsArrowClockwise, BsArrowCounterclockwise, BsArrowDown, BsArrowDownRight, BsArrowLeft, BsArrowRepeat, BsArrowRight, BsArrowUp, BsArrowUpRight, BsArrowsCollapse, BsArrowsFullscreen, BsArrowsMove, BsAspectRatio, BsBadge4K, BsBadgeAd, BsBadgeHd, BsBadgeTm, BsBadgeVr, BsBadgeWc, BsBagHeart, BsBalloonHeart, BsBasket3, BsBatteryCharging, BsBatteryFull, BsBatteryHalf, BsBezier2, BsBicycle, BsBluetooth, BsBookHalf, BsBoundingBox, BsBoxArrowInRight, BsBoxArrowRight, BsBrightnessHigh, BsBrightnessLow, BsBrilliance, BsBroadcast, BsCCircle, BsCake2, BsCalendar2Event, BsCalendarCheck, BsCalendarDay, BsCalendarEvent, BsCalendarHeart, BsCalendarMonth, BsCalendarPlus, BsCalendarRange, BsCalendarWeek, BsCalendarX, BsCamera2, BsCameraVideo, BsCapslock, BsCarFront, BsCardHeading, BsCardList, BsCartCheck, BsCartPlus, BsCashCoin, BsCashStack, BsCassette, BsCast, BsChatDots, BsChatHeart, BsChatLeftDots, BsChatQuote, BsChatSquareText, BsCheckAll, BsCheckSquare, BsCircle, BsCircleFill, BsCircleHalf, BsClipboard, BsClipboardCheck, BsClipboardData, BsCloudDownload, BsCloudUpload, BsCodeSquare, BsCoin, BsColumnsGap, BsConeStriped, BsCookie, BsCreditCard2Front, BsCrop, BsCupHot, BsCupStraw, BsCurrencyBitcoin, BsCurrencyDollar, BsCurrencyEuro, BsCurrencyExchange, BsCurrencyPound, BsCurrencyRupee, BsCurrencyYen, BsDashCircle, BsDeviceSsd, BsDiagram2, BsDiamond, BsDice5, BsDisc, BsDiscord, BsDisplay, BsDoorClosed, BsDoorOpen, BsDot, BsDpad, BsDropbox, BsDropletHalf, BsDuffle, BsEarbuds, BsEasel, BsEgg, BsEggFried, BsEject, BsEmojiAngry, BsEmojiAstonished, BsEmojiDizzy, BsEmojiExpressionless, BsEmojiFrown, BsEmojiGrimace, BsEmojiGrin, BsEmojiHeartEyes, BsEmojiKiss, BsEmojiLaughing, BsEmojiNeutral, BsEmojiSmile, BsEmojiSunglasses, BsEmojiSurprise, BsEmojiTear, BsEmojiWink, BsEnvelopeHeart, BsEnvelopeOpen, BsEnvelopePaper, BsEraser, BsEscape, BsEthernet, BsEvFront, BsEvStation, BsExclamationDiamond, BsExclamationTriangle, BsEyeSlash, BsEyedropper, BsFacebook, BsFan, BsFeather, BsFileEarmarkBarGraph, BsFileEarmarkBinary, BsFileEarmarkCheck, BsFileEarmarkCode, BsFileEarmarkFont, BsFileEarmarkLock, BsFileEarmarkMedical, BsFileEarmarkMusic, BsFileEarmarkPerson, BsFileEarmarkPlay, BsFileEarmarkRuled, BsFileEarmarkSlides, BsFileEarmarkSpreadsheet, BsFileEarmarkText, BsFiles, BsFlower2, BsFlower3, BsFolder2Open, BsFolderCheck, BsFolderPlus, BsFonts, BsForward, BsFuelPumpDiesel, BsGenderAmbiguous, BsGenderNeuter, BsGenderTrans, BsGit, BsGithub, BsGlobe2, BsGlobeAsiaAustralia, BsGlobeEuropeAfrica, BsGoogle, BsGpuCard, BsGraphDown, BsGrid, BsGrid3X3Gap, BsHCircle, BsHandIndex, BsHandThumbsUpFill, BsHash, BsHdd, BsHddRack, BsHdmi, BsHeadset, BsHeadsetVr, BsHeartArrow, BsHeartFill, BsHeartHalf, BsHeartbreak, BsHearts, BsHeptagon, BsHexagon, BsHighlighter, BsHourglassBottom, BsHourglassSplit, BsHourglassTop, BsHouseDoor, BsHouseHeart, BsHurricane, BsHypnotize, BsImages, BsInboxes, BsIncognito, BsInfoSquare, BsInputCursorText, BsInstagram, BsIntersect, BsJournalBookmark, BsJournalCheck, BsJournalMedical, BsJournalRichtext, BsJournalText, BsKanban, BsLadder, BsLaptop, BsLayers, BsLightbulbOff, BsLightningFill, BsLinkedin, BsListNested, BsListStars, BsListTask, BsLuggage, BsLungs, BsMagic, BsMagnet, BsMailbox, BsMailboxFlag, BsMap, BsMarkerTip, BsMegaphone, BsMemory, BsMic, BsMicFill, BsMicrosoft, BsMicrosoftTeams, BsModem, BsMoisture, BsMoon, BsMoonStars, BsMortarboard, BsMotherboard, BsMouse, BsMusicNote, BsMusicNoteBeamed, BsMusicNoteList, BsNewspaper, BsNintendoSwitch, BsNodePlus, BsNoiseReduction, BsOctagon, BsOption, BsOutlet, BsPCircle, BsPaintBucket, BsPalette, BsPassport, BsPatchCheck, BsPatchExclamation, BsPatchPlus, BsPatchQuestion, BsPaypal, BsPcDisplay, BsPeace, BsPen, BsPencil, BsPentagon, BsPeople, BsPercent, BsPerson, BsPersonArmsUp, BsPersonBadge, BsPersonCircle, BsPersonHeart, BsPersonRaisedHand, BsPersonVcard, BsPersonWorkspace, BsPhone, BsPhoneVibrate, BsPieChart, BsPiggyBank, BsPin, BsPinAngle, BsPinMap, BsPlayCircle, BsPlaystation, BsPlug, BsPlugin, BsPlusCircle, BsPostage, BsPostcard, BsPostcardHeart, BsPower, BsPrinter, BsProjector, BsPuzzle, BsQrCode, BsQrCodeScan, BsQuestionCircle, BsQuestionDiamond, BsQuote, BsRCircle, BsRadar, BsRadioactive, BsRainbow, BsReceipt, BsReceiptCutoff, BsReception4, BsRecycle, BsReddit, BsRegex, BsRepeat, BsReply, BsReplyAll, BsRobot, BsRouter, BsRss, BsSafe, BsSafe2, BsScooter, BsScrewdriver, BsSdCard, BsSegmentedNav, BsSend, BsSendCheck, BsServer, BsShadows, BsShield, BsShieldCheck, BsShieldExclamation, BsShieldLock, BsShieldPlus, BsShieldSlash, BsShift, BsShop, BsShopWindow, BsShuffle, BsSignpost, BsSignpostSplit, BsSim, BsSlack, BsSlashCircle, BsSmartwatch, BsSnow2, BsSoundwave, BsSpeaker, BsSpellcheck, BsSpotify, BsSquare, BsSquareFill, BsStar, BsStarFill, BsStarHalf, BsStars, BsSteam, BsStickies, BsSticky, BsStoplights, BsStopwatch, BsStripe, BsSuitClub, BsSuitDiamond, BsSuitHeart, BsSuitSpade, BsSuitcase, BsSun, BsSunglasses, BsSunrise, BsSunset, BsSymmetryVertical, BsTable, BsTablet, BsTags, BsTaxiFront, BsTelephone, BsTelephoneInbound, BsTelephoneOutbound, BsTerminal, BsThermometerHigh, BsThermometerSnow, BsThermometerSun, BsThreeDots, BsTicketDetailed, BsTicketPerforated, BsTiktok, BsTools, BsTornado, BsTrainFreightFront, BsTrainFront, BsTrainLightrailFront, BsTranslate, BsTransparency, BsTrash, BsTree, BsTrello, BsTriangle, BsTrophy, BsTruck, BsTruckFlatbed, BsTv, BsTwitch, BsTwitterX, BsUiChecks, BsUiRadios, BsUmbrella, BsUnion, BsUniversalAccess, BsUnlock, BsUpc, BsUpcScan, BsUsbDrive, BsUsbSymbol, BsVectorPen, BsVignette, BsVinyl, BsVirus, BsVirus2, BsVoicemail, BsWallet2, BsWatch, BsWater, BsWebcam, BsWhatsapp, BsWind, BsWindowStack, BsWindows, BsWrenchAdjustable, BsXCircle, BsXbox, BsYoutube } from 'react-icons/bs';
import { TbAlarm, TbAlarmSnooze, TbAlertTriangle, TbAlpha, TbAmbulance, TbAnchor, TbApi, TbApple, TbArchive, TbArmchair2, TbArrowsShuffle, TbAt, TbAtom, TbAxe, TbBabyBottle, TbBabyCarriage, TbBackpack, TbBallBaseball, TbBallBasketball, TbBallBowling, TbBallFootball, TbBallTennis, TbBallVolleyball, TbBandage, TbBarbell, TbBarcode, TbBat, TbBatteryAutomotive, TbBeach, TbBeer, TbBellRinging, TbBeta, TbBinary, TbBone, TbBooks, TbBottle, TbBow, TbBowl, TbBraces, TbBrain, TbBread, TbBriefcase2, TbBug, TbBuildingArch, TbBuildingBank, TbBuildingBridge, TbBuildingBridge2, TbBuildingBroadcastTower, TbBuildingCarousel, TbBuildingCastle, TbBuildingChurch, TbBuildingCircus, TbBuildingCommunity, TbBuildingCottage, TbBuildingEstate, TbBuildingFactory2, TbBuildingFortress, TbBuildingHospital, TbBuildingLighthouse, TbBuildingMosque, TbBuildingPavilion, TbBuildingSkyscraper, TbBuildingStadium, TbBuildingStore, TbBuildingTunnel, TbBuildingWarehouse, TbBuildingWindTurbine, TbBurger, TbBusinessplan, TbButterfly, TbCactus, TbCake, TbCalculator, TbCalendarDue, TbCalendarRepeat, TbCalendarStats, TbCalendarUser, TbCampfire, TbCandy, TbCards, TbCarrot, TbCat, TbCategory, TbCategory2, TbCertificate, TbChartArea, TbChartCandle, TbChartDonut, TbChartDots3, TbChartLine, TbChecklist, TbCheese, TbChefHat, TbCherry, TbChess, TbChessKing, TbChessKnight, TbChessQueen, TbChristmasTree, TbCircleDashed, TbCircleDotted, TbClipboardList, TbClipboardText, TbClock12, TbClock24, TbClockExclamation, TbClockHour3, TbClockHour9, TbCloudDataConnection, TbCloudFog, TbCloudRain, TbCloudSnow, TbCloudStorm, TbCoffee, TbCoins, TbConfetti, TbContainer, TbCooker, TbCricket, TbCross, TbCrown, TbCurrency, TbCurrencyCent, TbCurrencyEthereum, TbDatabase, TbDatabaseExport, TbDatabaseImport, TbDeer, TbDental, TbDentalBroken, TbDevices, TbDiamond, TbDice, TbDivide, TbDna, TbDogBowl, TbDroplets, TbEngine, TbEqual, TbEqualNot, TbEyeClosed, TbEyeglass, TbEyeglass2, TbFence, TbFileDiff, TbFileExport, TbFileImport, TbFileInvoice, TbFingerprint, TbFireExtinguisher, TbFireHydrant, TbFiretruck, TbFirstAidKit, TbFish, TbFishBone, TbFishHook, TbFlag3, TbFlame, TbFlask, TbFolders, TbForklift, TbForms, TbFridge, TbFriends, TbGaugeFilled, TbGavel, TbGhost, TbGift, TbGiftCard, TbGitBranch, TbGolf, TbGrill, TbHanger, TbHash, TbHeartBroken, TbHeartCheck, TbHeartHandshake, TbHeartRateMonitor, TbHeartbeat, TbHorse, TbHorseToy, TbHorseshoe, TbHotelService, TbIceCream, TbIceSkating, TbId, TbInfinity, TbIroning, TbKey, TbKeyboard, TbLanguage, TbLeaf, TbLego, TbLemon, TbLetterA, TbLetterB, TbLetterC, TbLetterD, TbLetterE, TbLetterF, TbLetterX, TbLetterZ, TbLifebuoy, TbListCheck, TbListDetails, TbListNumbers, TbListTree, TbLockHeart, TbLockOpen, TbLollipop, TbMan, TbManualGearbox, TbMap2, TbMapPin, TbMapPins, TbMapRoute, TbMassage, TbMath, TbMathFunction, TbMathPi, TbMeat, TbMedal, TbMedal2, TbMicrophone2, TbMicroscope, TbMilk, TbMilkshake, TbMoneybag, TbMoodAngry, TbMoodCry, TbMoodHappy, TbMoodHeart, TbMoodKid, TbMoodNerd, TbMoodNeutral, TbMoodSad, TbMoodSick, TbMoodSmile, TbMoped, TbMotorbike, TbMountain, TbMushroom, TbNeedleThread, TbNotebook, TbNotes, TbNumber, TbNumber0, TbNumber1, TbNumber2, TbNumber3, TbNumber4, TbNumber5, TbNumber6, TbNumber7, TbNumber8, TbNumber9, TbOld, TbOm, TbOmega, TbPackage, TbPackages, TbPaperclip, TbPaw, TbPennant, TbPentagram, TbPepper, TbPhoto, TbPiano, TbPig, TbPill, TbPizza, TbPlaneArrival, TbPlaneDeparture, TbPlanet, TbPlant, TbPlusMinus, TbPool, TbPresentation, TbProgress, TbPumpkinScary, TbPuzzle, TbPuzzle2, TbRadio, TbReceiptRefund, TbReceiptTax, TbReport, TbReportMoney, TbRings, TbRobotFace, TbRosetteNumber1, TbRosetteNumber2, TbRosetteNumber3, TbRuler, TbRulerMeasure, TbRun, TbSailboat, TbSalad, TbSalt, TbSausage, TbScale, TbSchool, TbSchoolBell, TbSeeding, TbServer2, TbSettingsAutomation, TbShip, TbShirt, TbShirtSport, TbShoe, TbShoppingBag, TbShovel, TbSitemap, TbSkateboard, TbSkull, TbSnowflake, TbSnowman, TbSock, TbSolarPanel, TbSoup, TbSpider, TbSpray, TbStack2, TbStack3, TbStarOff, TbStretching, TbSum, TbSunHigh, TbSunrise, TbSunset, TbSwimming, TbSword, TbSwords, TbTable, TbTableOptions, TbTag, TbTargetArrow, TbTelescope, TbTemperature, TbTent, TbTerminal2, TbTimeline, TbToiletPaper, TbToolsKitchen2, TbTower, TbTractor, TbTrees, TbTrekking, TbTrophy, TbTruckDelivery, TbUmbrella, TbUsersGroup, TbVaccine, TbVaccineBottle, TbVacuumCleaner, TbVersions, TbWash, TbWashDryclean, TbWashMachine, TbWebhook, TbWheelchair, TbWindmill, TbWindow, TbWoman, TbX, TbYoga, TbZoomScan, TbZzz } from 'react-icons/tb';
import { PiAddressBook, PiBaby, PiBackpack, PiBaseballCap, PiBird, PiBoat, PiBookOpenText, PiBoot, PiCake, PiChampagne, PiCloudSun, PiCompassTool, PiCookingPot, PiCouch, PiDress, PiFlagBanner, PiFlagCheckered, PiFlowerLotus, PiFlowerTulip, PiGlobeHemisphereWest, PiGlobeStand, PiGrains, PiHandCoins, PiHandFist, PiHandHeart, PiHandPalm, PiHandSoap, PiHandWaving, PiHandbag, PiHandsClapping, PiHandsPraying, PiHandshake, PiHighHeel, PiHoodie, PiJeep, PiMartini, PiNote, PiNotepad, PiPaintRoller, PiPants, PiPenNib, PiPersonArmsSpread, PiPersonSimpleBike, PiShrimp, PiSneaker, PiStarOfDavid, PiSuitcaseRolling, PiVan, PiWatch, PiWine, PiYinYang } from 'react-icons/pi';
import { LuBanana, LuBedDouble, LuBedSingle, LuBrain, LuBrainCircuit, LuCandyCane, LuClapperboard, LuClover, LuCroissant, LuDonut, LuDrumstick, LuDumbbell, LuFlashlight, LuFootprints, LuGamepad2, LuGlassWater, LuGlasses, LuGrape, LuHistory, LuHotel, LuKeyRound, LuLampCeiling, LuLampDesk, LuLampFloor, LuLightbulb, LuMicrowave, LuMountainSnow, LuOrbit, LuPackageOpen, LuPaintbrush, LuPalmtree, LuPartyPopper, LuPipette, LuSandwich, LuScanFace, LuSnowflake, LuSparkles, LuSquareDashedBottom, LuTestTube, LuTestTubes, LuTimer, LuTreeDeciduous, LuTrendingUp, LuUtensils, LuVegan, LuVote, LuWand2, LuWaves, LuWheat } from 'react-icons/lu';
import { MdOutlineApartment, MdOutlineArchitecture, MdOutlineBabyChangingStation, MdOutlineBloodtype, MdOutlineBrush, MdOutlineCake, MdOutlineCelebration, MdOutlineChecklistRtl, MdOutlineCheckroom, MdOutlineChildCare, MdOutlineCleaningServices, MdOutlineCoPresent, MdOutlineConstruction, MdOutlineCorporateFare, MdOutlineElectricalServices, MdOutlineEmergency, MdOutlineEngineering, MdOutlineFitnessCenter, MdOutlineGarage, MdOutlineGrass, MdOutlineGroups, MdOutlineHealthAndSafety, MdOutlineHearing, MdOutlineHistoryEdu, MdOutlineInterpreterMode, MdOutlineLinearScale, MdOutlineLocalAirport, MdOutlineLocalBar, MdOutlineLocalCafe, MdOutlineLocalFireDepartment, MdOutlineLocalGasStation, MdOutlineLocalHospital, MdOutlineLocalLaundryService, MdOutlineLocalLibrary, MdOutlineLocalMovies, MdOutlineLocalOffer, MdOutlineLocalParking, MdOutlineLocalPharmacy, MdOutlineLocalPolice, MdOutlineLocalPostOffice, MdOutlineOilBarrel, MdOutlinePassword, MdOutlinePets, MdOutlinePoll, MdOutlinePregnantWoman, MdOutlinePsychology, MdOutlineRealEstateAgent, MdOutlineRecordVoiceOver, MdOutlineRestaurant, MdOutlineRestaurantMenu, MdOutlineSchedule, MdOutlineSecurity, MdOutlineSelfImprovement, MdOutlineSell, MdOutlineSick, MdOutlineSignLanguage, MdOutlineSos, MdOutlineSpa, MdOutlineSportsGymnastics, MdOutlineSportsHockey, MdOutlineSportsMartialArts, MdOutlineSportsMma, MdOutlineSportsRugby, MdOutlineSquareFoot, MdOutlineStadium, MdOutlineVideoCall, MdOutlineViewInAr, MdOutlineWeekend } from 'react-icons/md';
import { GiAbacus, GiAirBalloon, GiAngelWings, GiAnt, GiAnvil, GiAquarius, GiAries, GiBarn, GiBearHead, GiBee, GiBigDiamondRing, GiBilledCap, GiBirdHouse, GiBookshelf, GiBowTie, GiBrickWall, GiCamel, GiCampingTent, GiCancer, GiCandleFlame, GiCandleLight, GiCandles, GiCanoe, GiCapricorn, GiCarWheel, GiCaravan, GiCardPick, GiCardRandom, GiCauldron, GiCaveEntrance, GiCctvCamera, GiChainsaw, GiChicken, GiCoins, GiComb, GiCow, GiCrab, GiCrane, GiCrown, GiCrucifix, GiCrystalBall, GiCrystalCluster, GiCrystalEarrings, GiDart, GiDeliveryDrone, GiDesk, GiDevilMask, GiDiamondRing, GiDinosaurBones, GiDinosaurRex, GiDiploma, GiDoctorFace, GiDolphin, GiDove, GiDragonHead, GiDragonfly, GiDrill, GiDrop, GiDrum, GiDrumKit, GiDuck, GiEagleHead, GiEasterEgg, GiEightBall, GiElephant, GiFairyWand, GiFarmTractor, GiFireworkRocket, GiFishingPole, GiFlamingo, GiFox, GiFrog, GiGears, GiGecko, GiGemNecklace, GiGemini, GiGems, GiGlassCelebration, GiGloves, GiGoat, GiGraduateCap, GiGraveyard, GiGreekTemple, GiGuitar, GiGuitarBassHead, GiHairStrands, GiHand, GiHandSaw, GiHedgehog, GiHouseKeys, GiHummingbird, GiIsland, GiKangaroo, GiKeyLock, GiKidneys, GiKite, GiKnightBanner, GiKoala, GiLadybug, GiLeo, GiLibra, GiLion, GiLipstick, GiLiver, GiLotus, GiMagicHat, GiMagicLamp, GiMapleLeaf, GiMaterialsScience, GiMermaid, GiMining, GiMirrorMirror, GiModernCity, GiMonclerJacket, GiMonkey, GiMusicalScore, GiNails, GiOctopus, GiOgre, GiOwl, GiPagoda, GiPaintedPottery, GiPanda, GiPaperCrane, GiParkBench, GiParrotHead, GiPartyFlags, GiPartyHat, GiPenguin, GiPerfumeBottle, GiPillDrop, GiPipes, GiPisces, GiPoliceBadge, GiPrayer, GiPrayerBeads, GiPresent, GiQuillInk, GiRabbit, GiRaccoonHead, GiRazor, GiRing, GiRingedPlanet, GiRobotGolem, GiRuneStone, GiSagittarius, GiSattelite, GiSaxophone, GiScorpio, GiScrew, GiScrollQuill, GiScrollUnfurled, GiSeahorse, GiSewingMachine, GiSewingString, GiShamrock, GiSheep, GiShield, GiSiren, GiSkeleton, GiSkis, GiSkullCrossedBones, GiSnail, GiSnake, GiSnowboard, GiSocks, GiSolderingIron, GiSpellBook, GiSpinalCoil, GiSprout, GiSquirrel, GiStamper, GiStapler, GiSteamLocomotive, GiSteeringWheel, GiStomach, GiStoneBlock, GiSurfBoard, GiSyringe, GiTap, GiTaurus, GiTheaterCurtains, GiThroneKing, GiTie, GiToolbox, GiToothbrush, GiTopHat, GiTowel, GiTrumpet, GiTurtle, GiUsaFlag, GiVillage, GiViolin, GiVirgo, GiWateringCan, GiWeight, GiWeightScale, GiWhistle, GiWinterGloves, GiWizardFace, GiWolfHead, GiWool, GiYarn } from 'react-icons/gi';

// Sept 2026 expansion: seventeen new domains and four thin ones topped up (see the sections at the foot of this file).
import { GiAlarmClock, GiAmbulance, GiAmphora, GiArmorVest, GiAsteroid, GiAstronautHelmet, GiAxeInStump, GiBabyBottle, GiBabyFace, GiBackpack, GiBallerinaShoes, GiBalloonDog, GiBalloons, GiBandageRoll, GiBarracks, GiBasket, GiBathtub, GiBattleAxe, GiBattleship, GiBeachBall, GiBeachBucket, GiBearFace, GiBeard, GiBedLamp, GiBeehive, GiBinoculars, GiBlackBook, GiBlackHoleBolas, GiBlood, GiBoar, GiBookCover, GiBookPile, GiBookmark, GiBootPrints, GiBoots, GiBowArrow, GiBroom, GiBubbles, GiBugNet, GiBull, GiBullets, GiBunker, GiBus, GiBusStop, GiCabbage, GiCampCookingPot, GiCampfire, GiCannonBall, GiCarBattery, GiCarDoor, GiCarKey, GiCarSeat, GiCarabiner, GiCardboardBox, GiCargoCrane, GiCargoCrate, GiCargoShip, GiCastle, GiCatapult, GiChestArmor, GiChisel, GiCityCar, GiClayBrick, GiCliffCrossing, GiClothJar, GiClothes, GiClothesline, GiClothespin, GiCog, GiCoinsPile, GiCometSpark, GiCompass, GiCorn, GiCornucopia, GiCrossbow, GiDaggers, GiDonkey, GiDuality, GiDustCloud, GiEarrings, GiEarthAfricaEurope, GiEarthAmerica, GiEarthAsiaOceania, GiEasel, GiEggClutch, GiEnvelope, GiExitDoor, GiEyelashes, GiF1Car, GiFamilyHouse, GiFamilyTree, GiFarmer, GiFeather, GiFertilizerBag, GiField, GiFilmProjector, GiFireAxe, GiFireExtinguisher, GiFishingBoat, GiFishingLure, GiFishingNet, GiFlatTire, GiFlood, GiFlyingFlag, GiForest, GiForestCamp, GiForklift, GiFruitTree, GiGalaxy, GiGasPump, GiGoldBar, GiGoose, GiGrapes, GiGreenhouse, GiGrenade, GiHalberd, GiHandOk, GiHandTruck, GiHanger, GiHazardSign, GiHeartInside, GiHeartWings, GiHelmet, GiHelp, GiHoneyJar, GiHoneycomb, GiHorseHead, GiHumanPyramid, GiIncense, GiInkSwirl, GiJeep, GiJerrycan, GiJetFighter, GiJetPack, GiJupiter, GiKatana, GiKidSlide, GiLantern, GiLanternFlame, GiLaurelCrown, GiLaurels, GiLeatherBoot, GiLifeBuoy, GiLifeJacket, GiLifeSupport, GiLips, GiLog, GiLunarModule, GiMaceHead, GiMailbox, GiMarsCuriosity, GiMeal, GiMechanicGarage, GiMedal, GiMedicalDrip, GiMedicalPack, GiMeditation, GiMeteorImpact, GiMilkCarton, GiMissileLauncher, GiMissileSwarm, GiMoneyStack, GiMoon, GiMoonOrbit, GiMountainCave, GiMountainClimbing, GiMountainRoad, GiMountains, GiMusket, GiMustache, GiNecklace, GiNewspaper, GiNotebook, GiObservatory, GiOpenBook, GiOrbit, GiOrbital, GiPaddles, GiPaintBrush, GiPaintBucket, GiPaintRoller, GiPalette, GiPaperBoat, GiPaperClip, GiPaperPlane, GiPaperTray, GiPapers, GiParachute, GiPathDistance, GiPeaceDove, GiPear, GiPearlNecklace, GiPencil, GiPencilBrush, GiPencilRuler, GiPerson, GiPigFace, GiPiggyBank, GiPineTree, GiPitchfork, GiPlanetCore, GiPlow, GiPlunger, GiPodium, GiPoison, GiPoisonBottle, GiPotato, GiPowder, GiPrisoner, GiPumpkin, GiPuzzle, GiQuill, GiRaceCar, GiRadarDish, GiRadarSweep, GiRadiations, GiRaft, GiRake, GiRam, GiRank1, GiRank2, GiRank3, GiRazorBlade, GiReceiveMoney, GiRecycle, GiRevolver, GiRibbon, GiRibbonMedal, GiRibbonShield, GiRifle, GiRiver, GiRocket, GiRocketFlight, GiRocketThruster, GiRockingChair, GiRolledCloth, GiRooster, GiRopeBridge, GiRopeCoil, GiRoundShield, GiSandCastle, GiSandsOfTime, GiSatelliteCommunication, GiScalpel, GiSchoolBag, GiScissors, GiScooter, GiScythe, GiSeedling, GiSergeant, GiSewingNeedle, GiShare, GiShieldBash, GiShower, GiSickle, GiSkiBoot, GiSkier, GiSleepingBag, GiSleepy, GiSmokeBomb, GiSoap, GiSolarPower, GiSolarSystem, GiSpaceShuttle, GiSpaceSuit, GiSpaceship, GiSpade, GiSparkPlug, GiSparkles, GiSpears, GiSpeedometer, GiSpray, GiStaplerHeavyDuty, GiStarFormation, GiStarsStack, GiSteam, GiSubmarine, GiSunCloud, GiSundial, GiSunflower, GiTalk, GiTank, GiTargetShot, GiTeamIdea, GiTeamUpgrade, GiTireIron, GiTomato, GiTooth, GiTornado, GiTowTruck, GiToyMallet, GiTrashCan, GiTreeGrowth, GiTrophyCup, GiUfo, GiVacuumCleaner, GiVineFlower, GiVineLeaf, GiVisoredHelm, GiWalkieTalkie, GiWarhammer, GiWashingMachine, GiWaterDrop, GiWaterFlask, GiWaterMill, GiWheat, GiWindmill, GiWindow, GiWoodBeam, GiWoodCanoe, GiWoodPile, GiWoodenCrate, GiWoodenFence, GiZipper } from 'react-icons/gi';
import { TbAbc, TbAccessible, TbAddressBook, TbAirConditioning, TbAlertCircle, TbAlertOctagon, TbAlertSquare, TbAlien, TbAntenna, TbAntennaBars5, TbAperture, TbArrowBackUp, TbArrowsMove, TbAtom2, TbAutomaticGearbox, TbAward, TbBadge, TbBadgeCc, TbBadges, TbBalloon, TbBallpen, TbBarrel, TbBasket, TbBasketCheck, TbBasketDiscount, TbBasketPlus, TbBasketStar, TbBath, TbBattery, TbBattery1, TbBattery4, TbBatteryCharging, TbBatteryEco, TbBell, TbBellOff, TbBike, TbBiohazard, TbBolt, TbBoltOff, TbBook, TbBook2, TbBookDownload, TbBookmark, TbBookmarks, TbBox, TbBoxMultiple, TbBoxMultiple1, TbBoxOff, TbBoxSeam, TbBriefcase, TbBroadcast, TbBrush, TbBugOff, TbBuilding, TbBuildingFactory, TbBulb, TbBulbOff, TbBus, TbBusStop, TbCamera, TbCameraOff, TbCameraPlus, TbCameraSelfie, TbCandle, TbCar, TbCarCrane, TbCarCrash, TbCarGarage, TbCarOff, TbCarSuv, TbCarTurbine, TbCaravan, TbCardboards, TbCash, TbCashBanknote, TbChalkboard, TbChargingPile, TbChartBar, TbChartPie, TbCheckbox, TbCheckupList, TbChisel, TbCircleDot, TbCircuitBulb, TbCircuitSwitchOpen, TbCircuitVoltmeter, TbClipboardCheck, TbClockHour4, TbClockShield, TbCloudComputing, TbCoin, TbCoinEuro, TbCoinPound, TbCoinRupee, TbCoinYen, TbColorPicker, TbColorSwatch, TbComet, TbCompass, TbCopyright, TbCreativeCommons, TbCreditCard, TbCurrentLocation, TbCut, TbDashboard, TbDeviceAnalytics, TbDeviceSpeaker, TbDeviceTablet, TbDice1, TbDice6, TbDimensions, TbDisc, TbDiscount, TbDiscountCheck, TbDoor, TbDoorExit, TbDrone, TbDroplet, TbDropletHalf2, TbEPassport, TbEggs, TbElevator, TbEyeOff, TbFeather, TbFileCertificate, TbFileText, TbFlag, TbFocus2, TbFolderSearch, TbGalaxy, TbGardenCart, TbGasStation, TbGlass, TbGps, TbHammer, TbHeadphones, TbHeadset, TbHeart, TbHelmet, TbHighlight, TbHome2, TbHomeBolt, TbHomeCheck, TbHomeCog, TbHomeDollar, TbHomeEco, TbHomeEdit, TbHomeHand, TbHomeHeart, TbHomeInfinity, TbHomeLink, TbHomeMove, TbHomeOff, TbHomePlus, TbHomeQuestion, TbHomeSearch, TbHomeShield, TbHomeSignal, TbHomeStats, TbIceCream2, TbIdBadge2, TbInbox, TbKayak, TbLayoutBoard, TbLicense, TbLivePhoto, TbLoader, TbLocation, TbMail, TbMailFast, TbMailForward, TbMailOff, TbMailOpened, TbMailbox, TbMap, TbMapPinCheck, TbMapPinHeart, TbMapPinOff, TbMapPinPin, TbMapPinPlus, TbMapPinSearch, TbMapPinStar, TbMapSearch, TbMessage, TbMessage2Star, TbMessageCircle, TbMessageDots, TbMessageReport, TbMessages, TbMeteor, TbMicrophone, TbMicrowave, TbMoodBoy, TbMoodCrazyHappy, TbMoodSing, TbMoon, TbMoon2, TbMoonStars, TbMovie, TbNeedle, TbNews, TbNumbers, TbNut, TbPackageExport, TbPackageImport, TbPackageOff, TbPaint, TbPalette, TbParking, TbPeace, TbPencil, TbPercentage, TbPhone, TbPhoneCall, TbPhoneIncoming, TbPhoneOff, TbPhoneOutgoing, TbPhotoEdit, TbPhotoHeart, TbPhotoOff, TbPhotoSearch, TbPin, TbPlane, TbPlant2, TbPlayerPause, TbPlayerPlay, TbPlayerRecord, TbPlayerSkipForward, TbPlayerStop, TbPlug, TbPlugConnected, TbPodium, TbPremiumRights, TbPrinter, TbQrcode, TbQuote, TbRadar2, TbRadioactive, TbReceipt, TbReceipt2, TbRecycle, TbRefresh, TbRegistered, TbReportAnalytics, TbRipple, TbRoad, TbRoadSign, TbRocket, TbRosette, TbRoute, TbRoute2, TbRubberStamp, TbRuler2, TbRuler3, TbSatellite, TbScan, TbScissors, TbScooterElectric, TbSection, TbSend, TbShieldCheck, TbShieldHalf, TbShoppingCart, TbShoppingCartCheck, TbShoppingCartOff, TbShoppingCartPlus, TbSignRight, TbSignature, TbSlideshow, TbSocial, TbSolarElectricity, TbSolarPanel2, TbSpeakerphone, TbSpeedboat, TbStairs, TbStar, TbStarFilled, TbStars, TbSteeringWheel, TbSticker, TbSun, TbTags, TbTarget, TbTemperaturePlus, TbThumbUp, TbTicket, TbToggleLeft, TbTool, TbTools, TbTopologyStar, TbTrademark, TbTrafficCone, TbTrafficLights, TbTrain, TbTrash, TbTrashX, TbTruckLoading, TbTruckOff, TbTruckReturn, TbUniverse, TbUrgent, TbUserCheck, TbUserPlus, TbUserQuestion, TbVideo, TbVideoOff, TbVinyl, TbVocabulary, TbVolume, TbVolumeOff, TbWallet, TbWashDry, TbWashDryFlat, TbWashEco, TbWashHand, TbWashTumbleDry, TbWeight, TbWheel, TbWifi, TbWifiOff, TbWindElectricity, TbWiper, TbWiperWash, TbWood, TbWorld, TbWorldHeart, TbWorldLatitude, TbWorldLongitude, TbWriting, TbZip, TbZoomInArea, TbZoomOutArea } from 'react-icons/tb';
import { MdConveyorBelt, MdOutlineArticle, MdOutlineCardGiftcard, MdOutlineDraw, MdOutlineFace, MdOutlineFamilyRestroom, MdOutlineInventory, MdOutlineInventory2, MdOutlineLibraryBooks, MdOutlineLoyalty, MdOutlinePointOfSale, MdOutlineRedeem, MdOutlineRocketLaunch, MdOutlineSatelliteAlt, MdOutlineShoppingBag, MdOutlineShoppingBasket, MdOutlineShoppingCart, MdOutlineShoppingCartCheckout, MdOutlineStickyNote2, MdOutlineStore } from 'react-icons/md';
import { LuBaby, LuBath, LuBook, LuBookCopy, LuBookKey, LuBookLock, LuBookMarked, LuBookOpen, LuBookTemplate, LuCakeSlice, LuCandy, LuFeather } from 'react-icons/lu';
import { PiNotebook, PiTreeEvergreen } from 'react-icons/pi';
import { LiaCashRegisterSolid, LiaDollySolid, LiaHatWizardSolid, LiaTruckPickupSolid, LiaXRaySolid } from 'react-icons/lia';
import { SiLinux } from 'react-icons/si';
import { TbBrowser, TbPyramid, TbTrowel } from 'react-icons/tb';
import { RiBearSmileLine, RiSafe2Line } from 'react-icons/ri';
import { MdOutlineMuseum, MdOutlinePropaneTank, MdOutlineViewQuilt, MdShelves } from 'react-icons/md';
import { GiShirtButton, GiToaster } from 'react-icons/gi';
import { PiChair, PiStarAndCrescent, PiVault } from 'react-icons/pi';
import { LuFilter } from 'react-icons/lu';


// CHEVRONS
export const CHEVRON_UP = BsChevronUp;
export const CHEVRON_DOWN = BsChevronDown;
export const CHEVRON_LEFT = BsChevronLeft;
export const CHEVRON_RIGHT = BsChevronRight;
export const CHEVRON_RIGHT_COMPACT = BsChevronCompactRight;



// SYMBOLS
export const PLUS = AiOutlinePlus; // plus icon - used for 'create new' buttons
export const MINUS = AiOutlineMinus; // minus icon - pairs with PLUS for increment buttons
export const PLUS_FILL = BsFillPlusSquareFill;
export const CLOSE = MdClose; // X - used to indicate delete or close
export const BACK_ARROW = MdKeyboardBackspace; // Left arrow used to indicate navigating back
export const SETTINGS_COG = AiFillSetting;

export const CHECK_CIRCLE_OUTLINE = BsCheckCircle;
export const CHECK_CIRCLE_FILL = BsCheckCircleFill;
export const BAN_CIRCLE = BsBan;

export const RATING_STAR_OUTLINE = AiOutlineStar;
export const RATING_STAR_FILL = AiFillStar;

export const ADMIN_BADGE = MdAdminPanelSettings;
export const COLOR_PALETTE = IoColorPaletteOutline;

export const CARD_ICON = RxIdCard;



// UI / NAV
export const PERSON = BsPersonFill; // generic person for user avatar
export const MENU_OUTLINE = AiOutlineMenu;
export const KEBAB = BsThreeDotsVertical;
export const DRAG_HANDLE = RxDragHandleDots2;
export const HELP_QUESTION_MARK = AiOutlineQuestionCircle;
export const MAGNIFYING_GLASS = AiOutlineSearch;
export const REFRESH = LuRefreshCw;
export const SORT_ASCENDING = TbSortAscendingLetters;
export const SORT_DESCENDING = TbSortDescendingLetters;
export const DOCUMENT = IoDocumentOutline;
export const BLANK_ICON = TbBorderNone;
export const SAVE_ICON = TfiSave;
export const TAG_ICON = BsTag;
export const COLLECTION_ICON = AppstoreOutlined;
export const LIST = BsListUl;
export const SHARE = ShareAltOutlined;
export const PAPERCLIP = BsPaperclip; // attachments
export const DOWNLOAD = BsDownload;
export const UPLOAD = BsUpload;



// ACTION GLYPHS
// One glyph per action verb, so the same action reads the same in every
// menu (see components/common/actionMenu.js for the taxonomy).
export const OPEN = BsBoxArrowUpRight; // navigate: open a record's own page
export const EDIT = BsPencilSquare; // record: edit
export const DUPLICATE = BsCopy; // record: duplicate
export const RELATE = BsDiagram3; // record: relate items
export const TRASH = BsTrash3; // destructive: delete
export const INFO = BsInfoCircle; // record details / provenance
export const HISTORY = BsClockHistory; // timestamps, view history



// FILE TYPES
// One icon per extension family, used by the attachments list and the admin
// attachments table (see getFileTypeIcon in components/common/AttachmentsSection).
// FILE (BsFileEarmark, above) is the fallback for anything unmapped.
export const FILE_PDF = BsFiletypePdf;
export const FILE_DOC = BsFiletypeDoc;
export const FILE_DOCX = BsFiletypeDocx;
export const FILE_XLS = BsFiletypeXls;
export const FILE_XLSX = BsFiletypeXlsx;
export const FILE_CSV = BsFiletypeCsv;
export const FILE_PPT = BsFiletypePpt;
export const FILE_PPTX = BsFiletypePptx;
export const FILE_TXT = BsFiletypeTxt;
export const FILE_MD = BsFiletypeMd;
export const FILE_ZIP = BsFileEarmarkZip;
export const FILE_IMAGE = BsFileEarmarkImage;



// DICTIONARY ICONS
export const CALENDAR = BsCalendarDate;
export const CALENDAR_CLOCK = TbCalendarTime;
export const CLOCK = BsClock;
export const NUM_123 = Bs123;
export const TEXT = TbTypography;
export const TEXT_MULTI = BsTextWrap;
export const TEXT_RICH = BsFileRichtext;
// A value with units (weight, length, temperature, ...) — the `measurement` type.
export const MEASUREMENT = BsRulers;
// A yes/no switch — the `boolean` type (and the switch affordance generally).
export const BOOLEAN = BsToggleOn;
// A keepr account — the `user` type (someone who signs in), and the "Me" affordances.
export const USER_ACCOUNT = BsPersonBadge;
// The three text-adjacent types (docs/plans/data-types.md decision 1). Each is
// an alias of the library icon that already draws the thing (RATING_STAR sets
// the precedent): the dictionary reads its type icons from THIS section, and a
// second glyph for "a telephone" would be one more thing to keep in step.
export const PHONE = BsTelephone;
export const EMAIL = BsEnvelope;
export const LOCATION = BsGeoAlt;
export const URL_ICON = BsLink45Deg;
export const RATING_STAR = RATING_STAR_OUTLINE;

export const DROPDOWN = TbSelect; // badge used in Collapse header for collection elements



// RICH TEXT TOOLBAR
export const FORMAT_BOLD = BsTypeBold;
export const FORMAT_ITALIC = BsTypeItalic;
export const FORMAT_STRIKETHROUGH = BsTypeStrikethrough;
export const FORMAT_H1 = BsTypeH1;
export const FORMAT_H2 = BsTypeH2;
export const FORMAT_H3 = BsTypeH3;
export const FORMAT_LIST_BULLET = BsListUl;
export const FORMAT_LIST_NUMBERED = BsListOl;
export const MARKDOWN_MARK = BsMarkdown;



//////////////////////////////////////////////////
//   
//   USER SELECTABLE
//   
//////////////////////////////////////////////////

// USER SELECTABLE
export const GIRL = MdOutlineGirl;
export const BOY = MdOutlineBoy;
export const SCHOOL = MdOutlineSchool;
export const FOOTBALL = MdSportsFootball;
export const HOME = MdOutlineHome;
export const CAR = MdDirectionsCar;
export const FILTER = LuFilter;
export const UFO = TbUfo;
export const DOG = TbDog;

// NUMBERS
// Circle
export const ICON_CIR_0 = Bs0Circle;
export const ICON_CIR_1 = Bs1Circle;
export const ICON_CIR_2 = Bs2Circle;
export const ICON_CIR_3 = Bs3Circle;
export const ICON_CIR_4 = Bs4Circle;
export const ICON_CIR_5 = Bs5Circle;
export const ICON_CIR_6 = Bs6Circle;
export const ICON_CIR_7 = Bs7Circle;
export const ICON_CIR_8 = Bs8Circle;
export const ICON_CIR_9 = Bs9Circle;

export const ACTIVITY = BsActivity;
export const AIRPLANE = BsAirplane;
export const ALARM = BsAlarm;
export const ABC_LOWER = BsAlphabet;
export const ABC_UPPER = BsAlphabetUppercase;
export const APP_SQUARE = BsApp;
export const ARCHIVE = BsArchive;
export const ARROW_DOWN_UP = BsArrowDownUp;
export const ARROW_LEFT_RIGHT = BsArrowLeftRight;
export const ARROW_THROUGH_HEART = BsArrowThroughHeart;
export const ASTERISK = BsAsterisk;
export const ICON_AT = BsAt;
export const AWARD = BsAward;
export const BACKPACK = BsBackpack;
export const BACKSPACE = BsBackspace;
export const BAG = BsBag;
export const BALLOON = BsBalloon;
export const BANDAID = BsBandaid;
export const BANK = BsBank;
export const BAR_CHART = BsBarChart;
export const GANTT = BsBarChartSteps;
export const BASKET = BsBasket2;
export const BATTERY = BsBattery;
export const BELL = BsBell;
export const BINOCULARS = BsBinoculars;
export const BODY_TEXT = BsBodyText;
export const BOOK = BsBook;
export const BOOKMARK = BsBookmark;
export const BOOMBOX = BsBoombox;
export const BOX = BsBox;
export const PACKAGE = BsBoxSeam;
export const BRACES = BsBraces;
export const BRACES_ASTERISK = BsBracesAsterisk;
export const BRICKS = BsBricks;
export const BRIEFCASE = BsBriefcase;
export const BRUSH = BsBrush;
export const BUCKET = BsBucket;
export const BUG = BsBug;
export const BUILDING = BsBuilding;
export const BUILDINGS = BsBuildings;
export const BULLSEYE = BsBullseye;
export const BUS = BsBusFrontFill;
export const CAKE = BsCake;
export const CALCULATOR = BsCalculator;
export const VIDEO_CAMERA = BsCameraReels;
export const CAMERA = BsCamera;
export const CAPSULE = BsCapsule;
export const CHECKLIST = BsCardChecklist;
// export const IMAGE = BsCardImage;
export const PARAGRAPH = BsCardText;
export const SHOPPING_CART = BsCart3;
export const CASH = BsCash;
export const CHAT = BsChat;
export const CHECK = BsCheck2;
export const CHECKBOX = BsCheck2Square;
export const CLOUD = BsCloud;
export const CODE = BsCode;
export const CODE_SLASH = BsCodeSlash;
export const COMMAND = BsCommand;
export const COMPASS = BsCompass;
export const CONE = BsCone;
export const CONTROLLER = BsController;
export const CPU = BsCpu;
export const CREDIT_CARD = BsCreditCard;
export const CROSSHAIR = BsCrosshair;
export const CUP = BsCup;
export const DATABASE = BsDatabase;
export const DROPLET = BsDroplet;
export const EAR = BsEar;
export const ENVELOPE = BsEnvelope;
export const EXCLAMATION_CIRCLE = BsExclamationCircle;
export const EYE = BsEye;
export const GLASSES = BsEyeglasses;
export const FILE = BsFileEarmark;
export const FILM = BsFilm;
export const FINGERPRINT = BsFingerprint;
export const FIRE = BsFire;
export const FLAG = BsFlag;
export const FLOPPY_DISK = BsFloppy;
export const FLOWER = BsFlower1;
export const FOLDER = BsFolder;
export const FUEL_PUMP = BsFuelPump;
export const FUNNEL = BsFunnel;
export const GEAR = BsGear;
export const GEM = BsGem;
export const GENDER_FEMALE = BsGenderFemale;
export const GENDER_MALE = BsGenderMale;
export const GEO_PIN = BsGeoAlt;
export const GIFT = BsGift;
export const GLOBE_LINES = BsGlobe;
export const GLOBE_AMERICAS = BsGlobeAmericas;
export const GRAPH_UP = BsGraphUp;
export const HAMMER = BsHammer;
export const HAND_INDEX_THUMB = BsHandIndexThumb;
export const HAND_THUMBS_DOWN = BsHandThumbsDown;
export const HAND_THUMBS_UP = BsHandThumbsUp;
export const HEART = BsHeart;
export const HEART_PULSE = BsHeartPulse;
export const HOURGLASS = BsHourglass;
export const HOUSE = BsHouse;
export const IMAGE = BsImage;
export const INBOX = BsInbox;
export const INFINITY = BsInfinity;
export const JOURNAL = BsJournal;
export const JOYSTICK = BsJoystick;
export const KEY = BsKey;
export const KEYBOARD = BsKeyboard;
export const LIFE_PRESERVER = BsLifePreserver;
export const LIGHT_BULB = BsLightbulb;
export const LIGHTNING = BsLightningCharge;
export const STACK = BsCollection; // multi add: several items from one form
// export const LINK = BsLink45Deg;
// export const CHECKLIST = BsListCheck;
export const LOCK = BsLock;
export const PRESCRIPTION_RX = BsPrescription;
export const ROCKET = BsRocketTakeoff;
export const SCISSORS = BsScissors;
export const SEARCH_GLASS = BsSearch;
export const SLIDERS = BsSliders;
export const WIFI = BsWifi;
export const WRENCH = BsWrench;
export const YIN_YANG = BsYinYang;
export const UNICORN = GiUnicorn;
export const SPEEDOMETER = BsSpeedometer2;
export const THERMOMETER = BsThermometerHalf;
export const GAUGE = TbGauge;
export const GLASSES_3D = Gi3DGlasses;
export const PISTOL = GiPistolGun;
export const PISTOL_2 = GiC96;
export const PISTOL_1911 = GiColtM1911;
export const SIX_SHOOTER = GiChaingun;
export const MACHINE_GUN = GiMachineGun;
export const GUN_MAGAZINE = GiMachineGunMagazine;
export const MINI_GUN = GiMinigun;
export const SHOTGUN_SHELLS = GiShotgunRounds;
export const HANDCUFFS = GiHandcuffs;
export const CROSS_GRAVE = GiHastyGrave;
export const HEALTH_CAPSULE = GiHealthCapsule;
export const HEADPHONES = GiHeadphones;
export const HEALING = GiHealing;
export const HEALING_SHIELD = GiHealingShield;
export const HEALTH_NORMAL = GiHealthNormal;
export const HEALTH_DECREASING = GiHealthDecrease;
export const HEALTH_INCREASE = GiHealthIncrease;
export const POTION = GiHealthPotion;
export const HEART_BATTERY = GiHeartBattery;
export const HEART_BEATS = GiHeartBeats;
export const HEART_DROP = GiHeartDrop;
export const HEART_ORGAN = GiHeartOrgan;
export const HEART_PLUS = GiHeartPlus;
export const HEART_2 = GiHearts;
export const GUN_BULLETS = GiHeavyBullets;
export const RAIN = GiHeavyRain;
export const HELICOPTER = GiHelicopter;
export const THREADED_NUT = GiHexagonalNut;
export const HIKING = GiHiking;
export const KNIFE_FORK = GiKnifeFork;
export const PAINT_BRUSH = GiLargePaintBrush;
export const LIGHTNING_ARC = GiLightningArc;
export const GUN_LUGER = GiLuger;
export const SCORPION = GiScorpion;
export const PIRATE_CANNON = GiPirateCannon;
export const CANNON = GiCannon;
export const FORK_KNIFE_SPOON = GiForkKnifeSpoon;
export const TRENCH_KNIFE = GiTrenchKnife;
export const BOWIE_KNIFE = GiBowieKnife;
export const SWISS_ARMY_KNIFE = GiSwissArmyKnife;

// CARE / HOME
// Beds & rest
export const BED = TbBed;
export const BED_FLAT = TbBedFlat;
export const HOSPITAL_BED = TbEmergencyBed;
export const PERSON_IN_BED = GiPersonInBed;
export const BUNK_BEDS = GiBunkBeds;
export const PILLOW = GiPillow;
// Seating
export const CHAIR = MdOutlineChair;
export const ARMCHAIR = TbArmchair;
export const ROCKING_CHAIR = LuRockingChair;
export const SOFA = TbSofa;
export const OFFICE_CHAIR = GiOfficeChair;
// People & mobility
export const PERSON_STANDING = BsPersonStanding;
export const PERSON_WALKING = BsPersonWalking;
export const PERSON_WHEELCHAIR = BsPersonWheelchair;
export const ACCESSIBLE = MdOutlineAccessible;
export const ELDERLY = MdOutlineElderly;
export const ELDERLY_WOMAN = MdOutlineElderlyWoman;
export const WALKER = MdOutlineAssistWalker;
export const CANE = TbCane;
export const CRUTCHES = TbCrutches;
// Clinical
export const STETHOSCOPE = TbStethoscope;
export const NURSE = TbNurse;
export const HOSPITAL = BsHospital;
export const MEDICAL_BAG = MdOutlineMedicalServices;
export const SYRINGE = MdOutlineVaccines;
export const PILLS = TbPills;
export const CAPSULE_PILL = BsCapsulePill;
export const HEART_MONITOR = MdOutlineMonitorHeart;
export const CLIPBOARD_PULSE = BsClipboard2Pulse;
// Bath & home
export const BATHTUB = MdOutlineBathtub;
export const SHOWER = MdOutlineShower;
export const TOILET = PiToilet;
export const LAMP = BsLamp;



//////////////////////////////////////////////////
//
//   USER SELECTABLE — LIBRARY
//
//   One export per icon, grouped by the picker category it appears under
//   (src/components/iconCategories.js). Search keywords for each live in
//   src/components/iconKeywords.js. To add an icon: import it above, export
//   it here under its category, then add it to both of those files.
//
//////////////////////////////////////////////////

// PEOPLE & FAMILY
export const PERSON_OUTLINE = BsPerson;
export const PEOPLE = BsPeople;
export const PERSON_CIRCLE = BsPersonCircle;
export const PERSON_BADGE = BsPersonBadge;
export const PERSON_HEART = BsPersonHeart;
export const PERSON_ARMS_UP = BsPersonArmsUp;
export const PERSON_RAISED_HAND = BsPersonRaisedHand;
export const PERSON_WORKSPACE = BsPersonWorkspace;
export const PEOPLE_GROUP = TbUsersGroup;
export const FRIENDS = TbFriends;
export const MAN = TbMan;
export const WOMAN = TbWoman;
export const BABY = PiBaby;
export const BABY_CARRIAGE = TbBabyCarriage;
export const BABY_BOTTLE = TbBabyBottle;
export const SENIOR = TbOld;
export const HANDSHAKE = PiHandshake;
export const HANDS_PRAYING = PiHandsPraying;
export const HAND_WAVING = PiHandWaving;
export const HANDS_CLAPPING = PiHandsClapping;
export const HAND_HEART = PiHandHeart;
export const HEART_HANDSHAKE = TbHeartHandshake;
export const MOOD_HAPPY = TbMoodHappy;
export const MOOD_SMILE = TbMoodSmile;
export const MOOD_NEUTRAL = TbMoodNeutral;
export const MOOD_SAD = TbMoodSad;
export const MOOD_ANGRY = TbMoodAngry;
export const MOOD_CRY = TbMoodCry;
export const MOOD_SICK = TbMoodSick;
export const MOOD_NERD = TbMoodNerd;
export const MOOD_KID = TbMoodKid;
export const GENDER_NEUTER = BsGenderNeuter;
export const GENDER_TRANS = BsGenderTrans;
export const GENDER_AMBIGUOUS = BsGenderAmbiguous;
export const FOOTPRINTS = LuFootprints;

// ANIMALS & PETS
export const CAT = TbCat;
export const PAW = TbPaw;
export const DOG_BOWL = TbDogBowl;
export const BONE = TbBone;
export const FISH = TbFish;
export const BIRD = PiBird;
export const HORSE = TbHorse;
export const HORSESHOE = TbHorseshoe;
export const DEER = TbDeer;
export const BUTTERFLY = TbButterfly;
export const SPIDER = TbSpider;
export const BAT = TbBat;
export const PIG = TbPig;
export const COW = GiCow;
export const CHICKEN = GiChicken;
export const SHEEP = GiSheep;
export const GOAT = GiGoat;
export const DUCK = GiDuck;
export const RABBIT = GiRabbit;
export const TURTLE = GiTurtle;
export const FROG = GiFrog;
export const SNAKE = GiSnake;
export const GECKO = GiGecko;
export const BEE = GiBee;
export const LADYBUG = GiLadybug;
export const ANT = GiAnt;
export const SNAIL = GiSnail;
export const OWL = GiOwl;
export const EAGLE = GiEagleHead;
export const PARROT = GiParrotHead;
export const HUMMINGBIRD = GiHummingbird;
export const FLAMINGO = GiFlamingo;
export const PENGUIN = GiPenguin;
export const FOX = GiFox;
export const WOLF = GiWolfHead;
export const BEAR = GiBearHead;
export const LION = GiLion;
export const ELEPHANT = GiElephant;
export const MONKEY = GiMonkey;
export const PANDA = GiPanda;
export const KOALA = GiKoala;
export const KANGAROO = GiKangaroo;
export const SQUIRREL = GiSquirrel;
export const HEDGEHOG = GiHedgehog;
export const RACCOON = GiRaccoonHead;
export const CAMEL = GiCamel;
export const DOLPHIN = GiDolphin;
export const OCTOPUS = GiOctopus;
export const CRAB = GiCrab;
export const SEAHORSE = GiSeahorse;
export const SHRIMP = PiShrimp;
export const DRAGONFLY = GiDragonfly;
export const DINOSAUR = GiDinosaurRex;
export const DRAGON = GiDragonHead;
export const FISH_HOOK = TbFishHook;
export const FISH_BONE = TbFishBone;

// NATURE & WEATHER
export const TREE = BsTree;
export const TREES = TbTrees;
export const TREE_DECIDUOUS = LuTreeDeciduous;
export const PALM_TREE = LuPalmtree;
export const LEAF = TbLeaf;
export const PLANT = TbPlant;
export const SEEDLING = TbSeeding;
export const CACTUS = TbCactus;
export const MUSHROOM = TbMushroom;
export const FLOWER_2 = BsFlower2;
export const FLOWER_3 = BsFlower3;
export const TULIP = PiFlowerTulip;
export const LOTUS = PiFlowerLotus;
export const CLOVER = LuClover;
export const WHEAT = LuWheat;
export const MOUNTAIN = TbMountain;
export const MOUNTAIN_SNOW = LuMountainSnow;
export const BEACH = TbBeach;
export const WAVES = LuWaves;
export const WATER = BsWater;
export const DROPLETS = TbDroplets;
export const SUN = BsSun;
export const SUNRISE = BsSunrise;
export const SUNSET = BsSunset;
export const MOON = BsMoon;
export const MOON_STARS = BsMoonStars;
export const STARS = BsStars;
export const CLOUD_SUN = PiCloudSun;
export const CLOUD_RAIN = TbCloudRain;
export const CLOUD_SNOW = TbCloudSnow;
export const CLOUD_STORM = TbCloudStorm;
export const CLOUD_FOG = TbCloudFog;
export const SNOWFLAKE = TbSnowflake;
export const WIND = BsWind;
export const TORNADO = BsTornado;
export const HURRICANE = BsHurricane;
export const RAINBOW = BsRainbow;
export const UMBRELLA = BsUmbrella;
export const THERMOMETER_SUN = BsThermometerSun;
export const THERMOMETER_SNOW = BsThermometerSnow;
export const TEMPERATURE = TbTemperature;
export const PLANET = TbPlanet;
export const GLOBE_EUROPE_AFRICA = BsGlobeEuropeAfrica;
export const GLOBE_ASIA = BsGlobeAsiaAustralia;
export const CAMPFIRE = TbCampfire;
export const TENT = TbTent;
export const FEATHER = BsFeather;
export const RECYCLE = BsRecycle;
export const SOLAR_PANEL = TbSolarPanel;
export const WIND_TURBINE = TbBuildingWindTurbine;
export const RADIOACTIVE = BsRadioactive;

// FOOD & DRINK
export const COFFEE = TbCoffee;
export const CUP_HOT = BsCupHot;
export const CUP_STRAW = BsCupStraw;
export const BEER = TbBeer;
export const WINE = PiWine;
export const MARTINI = PiMartini;
export const CHAMPAGNE = PiChampagne;
export const BOTTLE = TbBottle;
export const GLASS_WATER = LuGlassWater;
export const MILK = TbMilk;
export const MILKSHAKE = TbMilkshake;
export const PIZZA = TbPizza;
export const BURGER = TbBurger;
export const SANDWICH = LuSandwich;
export const SOUP = TbSoup;
export const SALAD = TbSalad;
export const BOWL = TbBowl;
export const BREAD = TbBread;
export const CROISSANT = LuCroissant;
export const CHEESE = TbCheese;
export const EGG = BsEgg;
export const EGG_FRIED = BsEggFried;
export const MEAT = TbMeat;
export const SAUSAGE = TbSausage;
export const DRUMSTICK = LuDrumstick;
export const APPLE = TbApple;
export const CHERRY = TbCherry;
export const LEMON = TbLemon;
export const BANANA = LuBanana;
export const GRAPES = LuGrape;
export const CARROT = TbCarrot;
export const PEPPER = TbPepper;
export const ICE_CREAM = TbIceCream;
export const COOKIE = BsCookie;
export const DONUT = LuDonut;
export const CANDY = TbCandy;
export const LOLLIPOP = TbLollipop;
export const CAKE_SLICE = BsCake2;
export const CHEF_HAT = TbChefHat;
export const UTENSILS = LuUtensils;
export const KITCHEN_TOOLS = TbToolsKitchen2;
export const COOKING_POT = PiCookingPot;
export const GRILL = TbGrill;
export const STOVE = TbCooker;
export const FRIDGE = TbFridge;
export const SALT = TbSalt;
export const GRAINS = PiGrains;
export const VEGAN = LuVegan;

// HOME & GARDEN
export const HOUSE_DOOR = BsHouseDoor;
export const HOUSE_HEART = BsHouseHeart;
export const COTTAGE = TbBuildingCottage;
export const DOOR = BsDoorClosed;
export const DOOR_OPEN = BsDoorOpen;
export const WINDOW = TbWindow;
export const FENCE = TbFence;
export const GARAGE = MdOutlineGarage;
export const LAMP_DESK = LuLampDesk;
export const LAMP_FLOOR = LuLampFloor;
export const LAMP_CEILING = LuLampCeiling;
export const LIGHT_BULB_OFF = BsLightbulbOff;
export const PLUG = BsPlug;
export const OUTLET = BsOutlet;
export const FAN = BsFan;
export const BED_DOUBLE = LuBedDouble;
export const BED_SINGLE = LuBedSingle;
export const COUCH = PiCouch;
export const ARMCHAIR_2 = TbArmchair2;
export const WASHING_MACHINE = TbWashMachine;
export const IRON = TbIroning;
export const VACUUM = TbVacuumCleaner;
export const BROOM = MdOutlineCleaningServices;
export const MICROWAVE = LuMicrowave;
export const TOILET_PAPER = TbToiletPaper;
export const SPRAY = TbSpray;
export const SHOVEL = TbShovel;
export const WATERING_CAN = GiWateringCan;
export const GARDEN_TROWEL = TbTrowel;
export const LAWN_MOWER = MdOutlineGrass;
export const TRACTOR = TbTractor;
export const BARN = GiBarn;
export const MAILBOX = BsMailbox;
export const KEY_ROUND = LuKeyRound;
export const TRASH_CAN = BsTrash;
export const POOL = TbPool;
export const TOWEL = GiTowel;
export const SOAP = PiHandSoap;
export const HANGER = TbHanger;
export const CANDLE = GiCandleFlame;

// VEHICLES & TRAVEL
export const CAR_FRONT = BsCarFront;
export const EV_CAR = BsEvFront;
export const EV_STATION = BsEvStation;
export const TRUCK = BsTruck;
export const TRUCK_FLATBED = BsTruckFlatbed;
export const PICKUP_TRUCK = LiaTruckPickupSolid;
export const VAN = PiVan;
export const JEEP = PiJeep;
export const TAXI = BsTaxiFront;
export const BICYCLE = BsBicycle;
export const MOTORCYCLE = TbMotorbike;
export const SCOOTER = BsScooter;
export const MOPED = TbMoped;
export const TRAIN = BsTrainFront;
export const TRAM = BsTrainLightrailFront;
export const FREIGHT_TRAIN = BsTrainFreightFront;
export const SHIP = TbShip;
export const SAILBOAT = TbSailboat;
export const BOAT = PiBoat;
export const ANCHOR = TbAnchor;
export const AIRPLANE_TAKEOFF = TbPlaneDeparture;
export const AIRPLANE_LANDING = TbPlaneArrival;
export const HOT_AIR_BALLOON = GiAirBalloon;
export const SUITCASE = BsSuitcase;
export const LUGGAGE = BsLuggage;
export const SUITCASE_ROLLING = PiSuitcaseRolling;
export const DUFFLE = BsDuffle;
export const PASSPORT = BsPassport;
export const TICKET = BsTicketPerforated;
export const TICKET_DETAILED = BsTicketDetailed;
export const MAP = BsMap;
export const MAP_ROUTE = TbMapRoute;
export const PIN_MAP = BsPinMap;
export const SIGNPOST = BsSignpost;
export const SIGNPOST_SPLIT = BsSignpostSplit;
export const HOTEL = LuHotel;
export const HOTEL_SERVICE = TbHotelService;
export const CARAVAN = GiCaravan;
export const TRAFFIC_LIGHT = BsStoplights;
export const PARKING = MdOutlineLocalParking;
export const STEERING_WHEEL = GiSteeringWheel;
export const TIRE = GiCarWheel;
export const CAR_BATTERY = TbBatteryAutomotive;
export const GEARBOX = TbManualGearbox;
export const FUEL_DIESEL = BsFuelPumpDiesel;
export const GLOBE_STAND = PiGlobeStand;

// SPORTS & FITNESS
export const SOCCER_BALL = TbBallFootball;
export const BASKETBALL = TbBallBasketball;
export const BASEBALL = TbBallBaseball;
export const TENNIS = TbBallTennis;
export const VOLLEYBALL = TbBallVolleyball;
export const BOWLING = TbBallBowling;
export const GOLF = TbGolf;
export const CRICKET = TbCricket;
export const HOCKEY = MdOutlineSportsHockey;
export const RUGBY = MdOutlineSportsRugby;
export const BOXING = MdOutlineSportsMma;
export const MARTIAL_ARTS = MdOutlineSportsMartialArts;
export const DUMBBELL = LuDumbbell;
export const BARBELL = TbBarbell;
export const RUNNING = TbRun;
export const SWIMMING = TbSwimming;
export const YOGA = TbYoga;
export const STRETCHING = TbStretching;
export const CYCLING = PiPersonSimpleBike;
export const HIKER = TbTrekking;
export const SKATEBOARD = TbSkateboard;
export const ICE_SKATE = TbIceSkating;
export const SKI = GiSkis;
export const SNOWBOARD = GiSnowboard;
export const SURFBOARD = GiSurfBoard;
export const KAYAK = GiCanoe;
export const TROPHY = BsTrophy;
export const MEDAL = TbMedal;
export const MEDAL_2 = TbMedal2;
export const WHISTLE = GiWhistle;
export const STOPWATCH = BsStopwatch;
export const TARGET_ARROW = TbTargetArrow;
export const BOW_ARROW = TbBow;
export const FISHING_ROD = GiFishingPole;
export const SHIRT_SPORT = TbShirtSport;
export const STADIUM = TbBuildingStadium;

// GAMES & HOBBIES
export const CHESS = TbChess;
export const CHESS_KNIGHT = TbChessKnight;
export const CHESS_KING = TbChessKing;
export const CHESS_QUEEN = TbChessQueen;
export const DICE = TbDice;
export const DICE_5 = BsDice5;
export const PLAYING_CARDS = TbCards;
export const SUIT_SPADE = BsSuitSpade;
export const SUIT_CLUB = BsSuitClub;
export const SUIT_DIAMOND = BsSuitDiamond;
export const SUIT_HEART = BsSuitHeart;
export const PUZZLE = BsPuzzle;
export const GAMEPAD = LuGamepad2;
export const PLAYSTATION = BsPlaystation;
export const XBOX = BsXbox;
export const NINTENDO_SWITCH = BsNintendoSwitch;
export const STEAM = BsSteam;
export const DPAD = BsDpad;
export const LEGO = TbLego;
export const TEDDY_BEAR = RiBearSmileLine;
export const TOY_HORSE = TbHorseToy;
export const KITE = GiKite;
export const MAGIC_WAND = LuWand2;
export const MAGIC_HAT = GiMagicHat;
export const CRYSTAL_BALL = GiCrystalBall;
export const SEWING_MACHINE = GiSewingMachine;
export const NEEDLE_THREAD = TbNeedleThread;
export const YARN = GiYarn;
export const WOOL = GiWool;
export const SPOOL = GiSewingString;
export const POTTERY = GiPaintedPottery;
export const ORIGAMI = GiPaperCrane;
export const STAMP = GiStamper;
export const POSTAGE = BsPostage;
export const COIN_COLLECTION = GiCoins;
export const COMIC = GiSpellBook;
export const PUZZLE_2 = TbPuzzle2;
export const BINGO = GiCardRandom;
export const DARTS = GiDart;
export const BILLIARDS = GiEightBall;
export const GARDENING_GLOVES = GiGloves;
export const TELESCOPE = TbTelescope;
export const BIRDHOUSE = GiBirdHouse;
export const MODEL_TRAIN = GiSteamLocomotive;

// ARTS & MUSIC
export const MUSIC_NOTE = BsMusicNote;
export const MUSIC_NOTES = BsMusicNoteBeamed;
export const MUSIC_LIST = BsMusicNoteList;
export const GUITAR = GiGuitar;
export const ELECTRIC_GUITAR = GiGuitarBassHead;
export const PIANO = TbPiano;
export const DRUM = GiDrum;
export const DRUM_KIT = GiDrumKit;
export const VIOLIN = GiViolin;
export const TRUMPET = GiTrumpet;
export const SAXOPHONE = GiSaxophone;
export const MUSICAL_SCORE = GiMusicalScore;
export const MICROPHONE = BsMic;
export const MICROPHONE_STAGE = TbMicrophone2;
export const VINYL = BsVinyl;
export const CASSETTE = BsCassette;
export const DISC = BsDisc;
export const SPEAKER = BsSpeaker;
export const EARBUDS = BsEarbuds;
export const SOUNDWAVE = BsSoundwave;
export const RADIO = TbRadio;
export const PALETTE = BsPalette;
export const EASEL = BsEasel;
export const PAINT_BUCKET = BsPaintBucket;
export const PAINT_ROLLER = PiPaintRoller;
export const PENCIL = BsPencil;
export const PEN = BsPen;
export const PEN_FOUNTAIN = PiPenNib;
export const QUILL = GiQuillInk;
export const HIGHLIGHTER = BsHighlighter;
export const MARKER = BsMarkerTip;
export const ERASER = BsEraser;
export const VECTOR_PEN = BsVectorPen;
export const CROP = BsCrop;
export const MASK_THEATER = GiTheaterCurtains;
export const DANCE = MdOutlineSportsGymnastics;
export const CLAPPERBOARD = LuClapperboard;
export const SCULPTURE = GiStoneBlock;
export const BOOKSHELF = MdShelves;
export const BOOK_HALF = BsBookHalf;
export const BOOKS = TbBooks;
export const NOTEBOOK = TbNotebook;
export const NEWSPAPER = BsNewspaper;
export const QUOTE = BsQuote;
export const TRANSLATE = BsTranslate;
export const POETRY = GiScrollQuill;

// MEDIA & PHOTOGRAPHY
export const IMAGES = BsImages;
export const CAMERA_2 = BsCamera2;
export const CAMERA_VIDEO = BsCameraVideo;
export const PHOTO = TbPhoto;
export const WEBCAM = BsWebcam;
export const PROJECTOR = BsProjector;
export const TV = BsTv;
export const DISPLAY = BsDisplay;
export const PLAY = BsPlayCircle;
export const CAST = BsCast;
export const BROADCAST = BsBroadcast;
export const RSS = BsRss;
export const PODCAST = BsMicFill;
export const YOUTUBE = BsYoutube;
export const INSTAGRAM = BsInstagram;
export const TIKTOK = BsTiktok;
export const FACEBOOK = BsFacebook;
export const TWITTER_X = BsTwitterX;
export const LINKEDIN = BsLinkedin;
export const REDDIT = BsReddit;
export const SPOTIFY = BsSpotify;
export const TWITCH = BsTwitch;
export const DISCORD = BsDiscord;
export const WHATSAPP = BsWhatsapp;
export const GITHUB = BsGithub;
export const STICKY_NOTE = BsSticky;
export const STICKIES = BsStickies;
export const CAMERA_3 = TbCamera;
export const CAMERA_PLUS = TbCameraPlus;
export const CAMERA_SELFIE = TbCameraSelfie;
export const CAMERA_OFF = TbCameraOff;
export const APERTURE = TbAperture;
export const FOCUS = TbFocus2;
export const LENS = TbCircleDot;
export const PHOTO_EDIT = TbPhotoEdit;
export const PHOTO_HEART = TbPhotoHeart;
export const PHOTO_SEARCH = TbPhotoSearch;
export const PHOTO_OFF = TbPhotoOff;
export const FILM_2 = TbMovie;
export const VIDEO_2 = TbVideo;
export const VIDEO_OFF = TbVideoOff;
export const PLAYER_PLAY = TbPlayerPlay;
export const PLAYER_PAUSE = TbPlayerPause;
export const PLAYER_STOP = TbPlayerStop;
export const PLAYER_RECORD = TbPlayerRecord;
export const PLAYER_SKIP = TbPlayerSkipForward;
export const MICROPHONE_3 = TbMicrophone;
export const PODCAST_2 = TbBroadcast;
export const LIVE = TbLivePhoto;
export const SLIDESHOW = TbSlideshow;
export const DRONE_CAMERA = TbDrone;
export const STUDIO = GiFilmProjector;
export const SPEAKER_3 = TbDeviceSpeaker;
export const VOLUME = TbVolume;
export const MUTE = TbVolumeOff;
export const VINYL_2 = TbVinyl;
export const SUBTITLES = TbBadgeCc;

// WORK & OFFICE
export const BRIEFCASE_2 = TbBriefcase2;
export const CLIPBOARD = BsClipboard;
export const CLIPBOARD_CHECK = BsClipboardCheck;
export const CLIPBOARD_DATA = BsClipboardData;
export const KANBAN = BsKanban;
export const LIST_TASK = BsListTask;
export const LIST_CHECK = TbListCheck;
export const CALENDAR_EVENT = BsCalendarEvent;
export const CALENDAR_CHECK = BsCalendarCheck;
export const CALENDAR_WEEK = BsCalendarWeek;
export const CALENDAR_HEART = BsCalendarHeart;
export const PRESENTATION = TbPresentation;
export const PRINTER = BsPrinter;
export const PAPERCLIP_2 = TbPaperclip;
export const STAPLER = GiStapler;
export const PIN = BsPin;
export const PIN_ANGLE = BsPinAngle;
export const INBOXES = BsInboxes;
export const SEND = BsSend;
export const TELEPHONE = BsTelephone;
export const HEADSET = BsHeadset;
export const PERSON_VCARD = BsPersonVcard;
export const MORTARBOARD = BsMortarboard;
export const DIAGRAM_2 = BsDiagram2;
export const GRAPH_DOWN = BsGraphDown;
export const PIE_CHART = BsPieChart;
export const CHART_LINE = TbChartLine;
export const CHART_DONUT = TbChartDonut;
export const CHART_AREA = TbChartArea;
export const REPORT = TbReport;
export const TABLE = BsTable;
export const SPREADSHEET = TbTableOptions;
export const BUSINESS_PLAN = TbBusinessplan;
export const CERTIFICATE = TbCertificate;
export const CONTRACT = MdOutlineHistoryEdu;
export const GAVEL = TbGavel;
export const SCALE_JUSTICE = TbScale;
export const VOTE = LuVote;
export const ID_BADGE = TbId;
export const DESK = GiDesk;
export const HOURGLASS_SPLIT = BsHourglassSplit;
export const STOPWATCH_2 = TbClockHour3;
export const BELL_SCHOOL = TbSchoolBell;
export const FLAG_CHECKERED = PiFlagCheckered;
export const PENNANT = TbPennant;

// MONEY & FINANCE
export const WALLET = BsWallet2;
export const PIGGY_BANK = BsPiggyBank;
export const COIN = BsCoin;
export const COINS = TbCoins;
export const CASH_STACK = BsCashStack;
export const CASH_COIN = BsCashCoin;
export const MONEY_BAG = TbMoneybag;
export const DOLLAR = BsCurrencyDollar;
export const EURO = BsCurrencyEuro;
export const POUND = BsCurrencyPound;
export const YEN = BsCurrencyYen;
export const RUPEE = BsCurrencyRupee;
export const BITCOIN = BsCurrencyBitcoin;
export const ETHEREUM = TbCurrencyEthereum;
export const CURRENCY_EXCHANGE = BsCurrencyExchange;
export const RECEIPT = BsReceipt;
export const RECEIPT_CUTOFF = BsReceiptCutoff;
export const INVOICE = TbFileInvoice;
export const TAX = TbReceiptTax;
export const REFUND = TbReceiptRefund;
export const PERCENT = BsPercent;
export const SAFE = BsSafe;
export const SAFE_2 = BsSafe2;
export const REPORT_MONEY = TbReportMoney;
export const CHART_CANDLE = TbChartCandle;
export const TRENDING_UP = LuTrendingUp;
export const CREDIT_CARD_2 = BsCreditCard2Front;
export const BANK_BUILDING = TbBuildingBank;
export const HAND_COINS = PiHandCoins;
export const CALCULATOR_2 = TbCalculator;
export const GIFT_CARD = TbGiftCard;
export const PAYPAL = BsPaypal;
export const STRIPE = BsStripe;

// SHOPPING & RETAIL
export const SHOP = BsShop;
export const SHOP_WINDOW = BsShopWindow;
export const STORE = TbBuildingStore;
export const CART_PLUS = BsCartPlus;
export const CART_CHECK = BsCartCheck;
export const SHOPPING_BAG = TbShoppingBag;
export const BAG_HEART = BsBagHeart;
export const BASKET_3 = BsBasket3;
export const TAGS = BsTags;
export const PRICE_TAG = TbTag;
export const BARCODE = TbBarcode;
export const UPC_SCAN = BsUpcScan;
export const QR_CODE = BsQrCode;
export const GIFT_2 = TbGift;
export const PACKAGE_2 = TbPackage;
export const PACKAGES = TbPackages;
export const TRUCK_DELIVERY = TbTruckDelivery;
export const BOX_OPEN = LuPackageOpen;
export const CONTAINER = TbContainer;
export const FORKLIFT = TbForklift;
export const WAREHOUSE = TbBuildingWarehouse;
export const AMAZON = BsAmazon;
export const APPLE_LOGO = BsApple;
export const GOOGLE = BsGoogle;
export const MICROSOFT = BsMicrosoft;
export const COUPON = MdOutlineLocalOffer;
export const SHOPPING_LIST = MdOutlineChecklistRtl;
export const CASH_REGISTER = LiaCashRegisterSolid;
export const HANDBAG = PiHandbag;
export const SCALE_WEIGHT = GiWeightScale;
export const SHOPPING_CART_2 = TbShoppingCart;
export const CART_PLUS_2 = TbShoppingCartPlus;
export const CART_CHECK_2 = TbShoppingCartCheck;
export const CART_OFF = TbShoppingCartOff;
export const RECEIPT_3 = TbReceipt;
export const TAGS_2 = TbTags;
export const DISCOUNT = TbDiscount;
export const COUPON_2 = TbTicket;
export const CREDIT_CARD_3 = TbCreditCard;
export const WALLET_2 = TbWallet;
export const RETURN = TbArrowBackUp;
export const SCAN = TbScan;
export const SUBSCRIPTION = TbRefresh;
export const SALE = TbPercentage;
export const SHOPPING_BAG_3 = MdOutlineShoppingBag;
export const SHOPPING_BASKET_2 = MdOutlineShoppingBasket;
export const SHOPPING_CART_3 = MdOutlineShoppingCart;
export const CHECKOUT = MdOutlineShoppingCartCheckout;
export const STORE_2 = MdOutlineStore;
export const POINT_OF_SALE = MdOutlinePointOfSale;
export const LOYALTY = MdOutlineLoyalty;
export const REDEEM = MdOutlineRedeem;
export const GIFT_CARD_3 = MdOutlineCardGiftcard;
export const INVENTORY_2 = MdOutlineInventory2;
export const INVENTORY_LIST = MdOutlineInventory;
export const CASH_2 = TbCash;
export const BANKNOTE = TbCashBanknote;
export const BASKET_PLUS = TbBasketPlus;
export const BASKET_CHECK = TbBasketCheck;
export const BASKET_DISCOUNT = TbBasketDiscount;
export const BASKET_STAR = TbBasketStar;
export const COIN_EURO = TbCoinEuro;
export const COIN_POUND = TbCoinPound;
export const COIN_YEN = TbCoinYen;
export const COIN_RUPEE = TbCoinRupee;
export const CHART_BAR = TbChartBar;
export const CHART_PIE_2 = TbChartPie;

// TECHNOLOGY & DEVICES
export const LAPTOP = BsLaptop;
export const PC_TOWER = BsPcDisplay;
export const SMARTPHONE = BsPhone;
export const TABLET = BsTablet;
export const SMARTWATCH = BsSmartwatch;
export const WATCH = BsWatch;
export const MOUSE = BsMouse;
export const KEYBOARD_2 = TbKeyboard;
export const HARD_DRIVE = BsHdd;
export const SSD = BsDeviceSsd;
export const USB_DRIVE = BsUsbDrive;
export const USB_SYMBOL = BsUsbSymbol;
export const SD_CARD = BsSdCard;
export const MEMORY = BsMemory;
export const GPU = BsGpuCard;
export const MOTHERBOARD = BsMotherboard;
export const SERVER = BsServer;
export const HDD_RACK = BsHddRack;
export const ROUTER = BsRouter;
export const MODEM = BsModem;
export const ETHERNET = BsEthernet;
export const BLUETOOTH = BsBluetooth;
export const HDMI = BsHdmi;
export const TERMINAL = BsTerminal;
export const CODE_SQUARE = BsCodeSquare;
export const GIT = BsGit;
export const ROBOT = BsRobot;
export const ROBOT_FACE = TbRobotFace;
export const BRAIN_CIRCUIT = LuBrainCircuit;
export const CLOUD_UPLOAD = BsCloudUpload;
export const CLOUD_DOWNLOAD = BsCloudDownload;
export const DEVICES = TbDevices;
export const PLUGIN = BsPlugin;
export const POWER = BsPower;
export const BATTERY_CHARGING = BsBatteryCharging;
export const BATTERY_FULL = BsBatteryFull;
export const BATTERY_HALF = BsBatteryHalf;
export const FLASHLIGHT = LuFlashlight;
export const PHONE_VIBRATE = BsPhoneVibrate;
export const SIM_CARD = BsSim;
export const RADAR = BsRadar;
export const SATELLITE = GiSattelite;
export const DRONE = GiDeliveryDrone;
export const VR_HEADSET = BsHeadsetVr;
export const PRINTER_3D = MdOutlineViewInAr;
export const ANDROID = BsAndroid2;
export const WINDOWS = BsWindows;
export const LINUX = SiLinux;
export const BROWSER = TbBrowser;
export const SLACK = BsSlack;
export const TEAMS = BsMicrosoftTeams;
export const DROPBOX = BsDropbox;
export const TRELLO = BsTrello;

// SCIENCE & EDUCATION
export const FLASK = TbFlask;
export const TEST_TUBE = LuTestTube;
export const TEST_TUBES = LuTestTubes;
export const ATOM = TbAtom;
export const DNA = TbDna;
export const MICROSCOPE = TbMicroscope;
export const MAGNET = BsMagnet;
export const ORBIT = LuOrbit;
export const RULER = TbRuler;
export const RULER_MEASURE = TbRulerMeasure;
export const COMPASS_DRAW = PiCompassTool;
export const ABACUS = GiAbacus;
export const PIPETTE = LuPipette;
export const BOOK_OPEN = PiBookOpenText;
export const BACKPACK_2 = TbBackpack;
export const CHALKBOARD = TbChalkboard;
export const CLASS = MdOutlineCoPresent;
export const GRADUATION = TbSchool;
export const DIPLOMA = GiDiploma;
export const LIGHT_BULB_IDEA = LuLightbulb;
export const MATH = TbMath;
export const MATH_FUNCTION = TbMathFunction;
export const PI_SYMBOL = TbMathPi;
export const LANGUAGE = TbLanguage;
export const BINARY = TbBinary;
export const GLOBE_2 = BsGlobe2;
export const MUSEUM = MdOutlineMuseum;
export const LIBRARY = GiBookshelf;
export const PLANETARIUM = GiRingedPlanet;
export const BRAIN = TbBrain;
export const PUZZLE_BRAIN = TbPuzzle;
export const SPELLCHECK = BsSpellcheck;
export const FONTS = BsFonts;
export const DIAGRAM = TbChartDots3;
export const PERIODIC_TABLE = GiMaterialsScience;
export const DINOSAUR_BONES = GiDinosaurBones;
export const MAP_2 = TbMap2;

// HEALTH & MEDICINE
export const TOOTH = TbDental;
export const TOOTH_BROKEN = TbDentalBroken;
export const LUNGS = BsLungs;
export const EYE_EXAM = TbEyeglass;
export const EYE_CLOSED = TbEyeClosed;
export const VIRUS = BsVirus;
export const VIRUS_2 = BsVirus2;
export const BANDAGE = TbBandage;
export const FIRST_AID_KIT = TbFirstAidKit;
export const MEDICAL_CROSS = TbCross;
export const AMBULANCE = TbAmbulance;
export const HOSPITAL_BUILDING = TbBuildingHospital;
export const PILL = TbPill;
export const PILL_BOTTLE = GiPillDrop;
export const VACCINE = TbVaccine;
export const VACCINE_BOTTLE = TbVaccineBottle;
export const WHEELCHAIR = TbWheelchair;
export const HEART_RATE_MONITOR = TbHeartRateMonitor;
export const HEARTBEAT = TbHeartbeat;
export const BRAIN_HEALTH = LuBrain;
export const SKELETON = GiSkeleton;
export const SPINE = GiSpinalCoil;
export const KIDNEYS = GiKidneys;
export const LIVER = GiLiver;
export const STOMACH = GiStomach;
export const BLOOD_DROP = GiDrop;
export const BLOOD_PRESSURE = MdOutlineBloodtype;
export const SCALE_BODY = GiWeight;
export const NUTRITION = MdOutlineRestaurant;
export const SLEEP = TbZzz;
export const MEDITATION = MdOutlineSelfImprovement;
export const SPA = MdOutlineSpa;
export const MASSAGE = TbMassage;
export const THERAPY = MdOutlinePsychology;
export const HEARING_AID = MdOutlineHearing;
export const GLASSES_2 = LuGlasses;
export const DOCTOR = GiDoctorFace;
export const NURSE_2 = MdOutlineHealthAndSafety;
export const CLINIC = MdOutlineLocalHospital;
export const PHARMACY = MdOutlineLocalPharmacy;
export const DIABETES = GiSyringe;
export const ALLERGY = MdOutlineSick;
export const PREGNANCY = MdOutlinePregnantWoman;
export const BABY_CHANGING = MdOutlineBabyChangingStation;
export const CHILD_CARE = MdOutlineChildCare;
export const MENTAL_HEALTH = TbMoodHeart;
export const XRAY = LiaXRaySolid;
export const TOOTHBRUSH = GiToothbrush;
export const THERMOMETER_HIGH = BsThermometerHigh;
export const HEART_BROKEN = TbHeartBroken;
export const HEART_CHECK = TbHeartCheck;
export const EYEDROPPER = BsEyedropper;

// TOOLS & BUILDING
export const TOOLS = BsTools;
export const SCREWDRIVER = BsScrewdriver;
export const WRENCH_ADJUSTABLE = BsWrenchAdjustable;
export const AXE = TbAxe;
export const SAW = GiHandSaw;
export const DRILL = GiDrill;
export const LADDER = BsLadder;
export const TOOLBOX = GiToolbox;
export const NAIL = GiNails;
export const SCREW = GiScrew;
export const PAINT_BRUSH_2 = LuPaintbrush;
export const MEASURING_TAPE = MdOutlineSquareFoot;
export const HARD_HAT = MdOutlineEngineering;
export const CONSTRUCTION = MdOutlineConstruction;
export const CRANE = GiCrane;
export const EXCAVATOR = GiMining;
export const BLUEPRINT = MdOutlineArchitecture;
export const GEARS = GiGears;
export const ANVIL = GiAnvil;
export const PIPE = GiPipes;
export const FAUCET = GiTap;
export const ELECTRICITY = MdOutlineElectricalServices;
export const FIRE_EXTINGUISHER = TbFireExtinguisher;
export const FIRE_HYDRANT = TbFireHydrant;
export const FIRE_TRUCK = TbFiretruck;
export const LOCKSMITH = GiKeyLock;
export const ENGINE = TbEngine;
export const OIL_CAN = MdOutlineOilBarrel;
export const SOLDERING = GiSolderingIron;
export const CHAINSAW = GiChainsaw;
export const MAGNIFYING_TOOL = TbZoomScan;

// CLOTHING & ACCESSORIES
export const SHIRT = TbShirt;
export const DRESS = PiDress;
export const PANTS = PiPants;
export const HOODIE = PiHoodie;
export const COAT = GiMonclerJacket;
export const SHOE = TbShoe;
export const SNEAKER = PiSneaker;
export const BOOT = PiBoot;
export const HIGH_HEEL = PiHighHeel;
export const SOCK = TbSock;
export const HAT = GiBilledCap;
export const TOP_HAT = GiTopHat;
export const BASEBALL_CAP = PiBaseballCap;
export const TIE = GiTie;
export const BOW_TIE = GiBowTie;
export const SUNGLASSES = BsSunglasses;
export const RING = GiRing;
export const DIAMOND_RING = GiDiamondRing;
export const NECKLACE = GiGemNecklace;
export const EARRINGS = GiCrystalEarrings;
export const CROWN = TbCrown;
export const DIAMOND = TbDiamond;
export const GEMS = GiGems;
export const PERFUME = GiPerfumeBottle;
export const LIPSTICK = GiLipstick;
export const MAKEUP = MdOutlineBrush;
export const COMB = GiComb;
export const HAIR_DRYER = GiHairStrands;
export const RAZOR = GiRazor;
export const MIRROR = GiMirrorMirror;
export const SCARF = GiWinterGloves;
export const BACKPACK_FASHION = PiBackpack;
export const UMBRELLA_2 = TbUmbrella;
export const WATCH_2 = PiWatch;
export const GLASSES_ROUND = TbEyeglass2;
export const LAUNDRY = TbWash;
export const DRY_CLEAN = TbWashDryclean;
export const SHOPPING_WARDROBE = MdOutlineCheckroom;

// PLACES & BUILDINGS
export const CASTLE = TbBuildingCastle;
export const CHURCH_BUILDING = TbBuildingChurch;
export const MOSQUE = TbBuildingMosque;
export const SKYSCRAPER = TbBuildingSkyscraper;
export const FACTORY = TbBuildingFactory2;
export const LIGHTHOUSE = TbBuildingLighthouse;
export const BRIDGE = TbBuildingBridge;
export const BRIDGE_2 = TbBuildingBridge2;
export const CAROUSEL = TbBuildingCarousel;
export const CIRCUS = TbBuildingCircus;
export const ARCH = TbBuildingArch;
export const PAVILION = TbBuildingPavilion;
export const COMMUNITY = TbBuildingCommunity;
export const ESTATE = TbBuildingEstate;
export const FORTRESS = TbBuildingFortress;
export const TUNNEL = TbBuildingTunnel;
export const TOWER = TbTower;
export const WINDMILL = TbWindmill;
export const BROADCAST_TOWER = TbBuildingBroadcastTower;
export const TEMPLE = GiGreekTemple;
export const PAGODA = GiPagoda;
export const PYRAMID = TbPyramid;
export const STATUE_LIBERTY = GiUsaFlag;
export const CITY = GiModernCity;
export const VILLAGE = GiVillage;
export const ISLAND = GiIsland;
export const CAVE = GiCaveEntrance;
export const PARK = GiParkBench;
export const PLAYGROUND = GiKidSlide;
export const CEMETERY = GiGraveyard;
export const AIRPORT = MdOutlineLocalAirport;
export const GAS_STATION = MdOutlineLocalGasStation;
export const RESTAURANT = MdOutlineRestaurantMenu;
export const CAFE = MdOutlineLocalCafe;
export const BAR = MdOutlineLocalBar;
export const CINEMA = MdOutlineLocalMovies;
export const GYM = MdOutlineFitnessCenter;
export const LAUNDROMAT = MdOutlineLocalLaundryService;
export const POST_OFFICE = MdOutlineLocalPostOffice;
export const POLICE = MdOutlineLocalPolice;
export const FIRE_STATION = MdOutlineLocalFireDepartment;
export const LIBRARY_BUILDING = MdOutlineLocalLibrary;
export const ZOO = MdOutlinePets;
export const STADIUM_2 = MdOutlineStadium;
export const CAMPGROUND = GiCampingTent;
export const FARM = GiFarmTractor;
export const OFFICE_BUILDING = MdOutlineCorporateFare;
export const APARTMENT = MdOutlineApartment;
export const REAL_ESTATE = MdOutlineRealEstateAgent;
export const FOR_SALE = MdOutlineSell;
export const MAP_PIN_2 = TbMapPin;
export const MAP_PINS = TbMapPins;
export const GLOBE_HEMISPHERE = PiGlobeHemisphereWest;

// COMMUNICATION
export const CHAT_DOTS = BsChatDots;
export const CHAT_HEART = BsChatHeart;
export const CHAT_QUOTE = BsChatQuote;
export const CHAT_SQUARE_TEXT = BsChatSquareText;
export const CHAT_LEFT_RIGHT = BsChatLeftDots;
export const ENVELOPE_OPEN = BsEnvelopeOpen;
export const ENVELOPE_HEART = BsEnvelopeHeart;
export const ENVELOPE_PAPER = BsEnvelopePaper;
export const MAILBOX_FLAG = BsMailboxFlag;
export const MEGAPHONE = BsMegaphone;
export const TELEPHONE_OUTBOUND = BsTelephoneOutbound;
export const TELEPHONE_INBOUND = BsTelephoneInbound;
export const VOICEMAIL = BsVoicemail;
export const POSTCARD = BsPostcard;
export const POSTCARD_HEART = BsPostcardHeart;
export const SEND_CHECK = BsSendCheck;
export const REPLY = BsReply;
export const REPLY_ALL = BsReplyAll;
export const FORWARD = BsForward;
export const BELL_RING = TbBellRinging;
export const SIGNAL = BsReception4;
export const CONTACT_BOOK = PiAddressBook;
export const AT_SIGN = TbAt;
export const HASHTAG = BsHash;
export const SPEECH = MdOutlineRecordVoiceOver;
export const INTERPRETER = MdOutlineInterpreterMode;
export const HANDS_SIGN = MdOutlineSignLanguage;
export const MEETING = MdOutlineGroups;
export const VIDEO_CALL = MdOutlineVideoCall;
export const MAIL_OPENED = TbMailOpened;
export const MAIL_FORWARD = TbMailForward;
export const MAIL_FAST = TbMailFast;
export const MAIL_OFF = TbMailOff;
export const MAILBOX_2 = TbMailbox;
export const MESSAGE_2 = TbMessage;
export const MESSAGE_CIRCLE = TbMessageCircle;
export const MESSAGE_DOTS = TbMessageDots;
export const MESSAGES = TbMessages;
export const MESSAGE_REPORT = TbMessageReport;
export const PHONE_2 = TbPhone;
export const PHONE_INCOMING = TbPhoneIncoming;
export const PHONE_OUTGOING = TbPhoneOutgoing;
export const PHONE_OFF = TbPhoneOff;
export const SEND_2 = TbSend;
export const INBOX_2 = TbInbox;
export const BELL_2 = TbBell;
export const BELL_OFF = TbBellOff;
export const ANTENNA = TbAntenna;
export const WIFI_2 = TbWifi;
export const WIFI_OFF = TbWifiOff;
export const SIGNAL_BARS = TbAntennaBars5;
export const FAX = TbPrinter;
export const CHAT_SUPPORT = TbHeadset;
export const CONTACT_BOOK_2 = TbAddressBook;
export const FEEDBACK = TbMessage2Star;

// SECURITY
export const SHIELD = BsShield;
export const SHIELD_CHECK = BsShieldCheck;
export const SHIELD_LOCK = BsShieldLock;
export const SHIELD_EXCLAMATION = BsShieldExclamation;
export const SHIELD_SLASH = BsShieldSlash;
export const SHIELD_PLUS = BsShieldPlus;
export const UNLOCK = BsUnlock;
export const LOCK_OPEN = TbLockOpen;
export const KEY_2 = TbKey;
export const PASSWORD = MdOutlinePassword;
export const INCOGNITO = BsIncognito;
export const EYE_SLASH = BsEyeSlash;
export const CCTV = GiCctvCamera;
export const FACE_SCAN = LuScanFace;
export const SAFE_BOX = PiVault;
export const ALARM_SYSTEM = MdOutlineSecurity;
export const POLICE_BADGE = GiPoliceBadge;
export const SIREN = GiSiren;
export const PADLOCK_HEART = TbLockHeart;
export const BUG_SECURITY = TbBug;
export const FIREWALL = GiBrickWall;
export const KEYS = GiHouseKeys;
export const VAULT = RiSafe2Line;
export const WARNING = TbAlertTriangle;
export const CAUTION = BsConeStriped;
export const SKULL_CROSSBONES = GiSkullCrossedBones;
export const EMERGENCY = MdOutlineEmergency;
export const SOS = MdOutlineSos;
export const LIFE_RING = TbLifebuoy;

// CELEBRATIONS & HOLIDAYS
export const BALLOON_HEART = BsBalloonHeart;
export const CONFETTI = TbConfetti;
export const PARTY_POPPER = LuPartyPopper;
export const PARTY_HAT = GiPartyHat;
export const FIREWORKS = GiFireworkRocket;
export const CHRISTMAS_TREE = TbChristmasTree;
export const SNOWMAN = TbSnowman;
export const CANDY_CANE = LuCandyCane;
export const PRESENT = GiPresent;
export const STOCKING = GiSocks;
export const PUMPKIN = TbPumpkinScary;
export const GHOST = TbGhost;
export const SKULL = TbSkull;
export const WITCH_HAT = LiaHatWizardSolid;
export const EASTER_EGG = GiEasterEgg;
export const SHAMROCK = GiShamrock;
export const HEART_ARROW = BsHeartArrow;
export const WEDDING_RINGS = TbRings;
export const BRIDE = GiBigDiamondRing;
export const CAKE_3 = TbCake;
export const CANDLES = GiCandles;
export const GRADUATION_CAP = GiGraduateCap;
export const CHAMPAGNE_TOAST = GiGlassCelebration;
export const FLAG_BANNER = PiFlagBanner;
export const BUNTING = GiPartyFlags;
export const BIRTHDAY = MdOutlineCake;
export const MEMORIAL = GiCandleLight;
export const ANNIVERSARY = MdOutlineCelebration;

// FAITH & MYTHOLOGY
export const CROSS = GiCrucifix;
export const STAR_OF_DAVID = PiStarOfDavid;
export const CRESCENT = PiStarAndCrescent;
export const OM = TbOm;
export const PRAYER_BEADS = GiPrayerBeads;
export const PRAYER = GiPrayer;
export const ANGEL = GiAngelWings;
export const DEVIL = GiDevilMask;
export const PEACE = BsPeace;
export const PENTAGRAM = TbPentagram;
export const ZODIAC_ARIES = GiAries;
export const ZODIAC_TAURUS = GiTaurus;
export const ZODIAC_GEMINI = GiGemini;
export const ZODIAC_CANCER = GiCancer;
export const ZODIAC_LEO = GiLeo;
export const ZODIAC_VIRGO = GiVirgo;
export const ZODIAC_LIBRA = GiLibra;
export const ZODIAC_SCORPIO = GiScorpio;
export const ZODIAC_SAGITTARIUS = GiSagittarius;
export const ZODIAC_CAPRICORN = GiCapricorn;
export const ZODIAC_AQUARIUS = GiAquarius;
export const ZODIAC_PISCES = GiPisces;
export const TAROT = GiCardPick;
export const CAULDRON = GiCauldron;
export const WIZARD = GiWizardFace;
export const SWORD = TbSword;
export const SWORDS = TbSwords;
export const SHIELD_MEDIEVAL = GiShield;
export const KNIGHT_HELMET = GiKnightBanner;
export const CROWN_ROYAL = GiCrown;
export const THRONE = GiThroneKing;
export const SCROLL = GiScrollUnfurled;
export const RUNE = GiRuneStone;
export const MERMAID = GiMermaid;
export const FAIRY = GiFairyWand;
export const GENIE_LAMP = GiMagicLamp;
export const TROLL = GiOgre;
export const ROBOT_GOLEM = GiRobotGolem;
export const CRYSTAL = GiCrystalCluster;
export const INFINITY_2 = TbInfinity;
export const YIN_YANG_2 = PiYinYang;
export const DOVE = GiDove;
export const LOTUS_2 = GiLotus;
export const HAMSA = GiHand;

// TIME & CALENDAR
export const CALENDAR_PLUS = BsCalendarPlus;
export const CALENDAR_X = BsCalendarX;
export const CALENDAR_RANGE = BsCalendarRange;
export const CALENDAR_MONTH = BsCalendarMonth;
export const CALENDAR_DAY = BsCalendarDay;
export const CALENDAR_2 = BsCalendar2Event;
export const CALENDAR_REPEAT = TbCalendarRepeat;
export const CALENDAR_STATS = TbCalendarStats;
export const CALENDAR_DUE = TbCalendarDue;
export const CALENDAR_USER = TbCalendarUser;
export const CLOCK_2 = TbClockHour9;
export const ALARM_2 = TbAlarm;
export const TIMER = LuTimer;
export const HOURGLASS_TOP = BsHourglassTop;
export const HOURGLASS_BOTTOM = BsHourglassBottom;
export const SUNRISE_2 = TbSunrise;
export const SUNSET_2 = TbSunset;
export const CLOCK_12 = TbClock12;
export const CLOCK_24 = TbClock24;
export const HISTORY_2 = LuHistory;
export const REPEAT = BsRepeat;
export const SHUFFLE = BsShuffle;
export const SNOOZE = TbAlarmSnooze;
export const SEASON_SPRING = GiSprout;
export const SEASON_SUMMER = TbSunHigh;
export const SEASON_FALL = GiMapleLeaf;
export const SEASON_WINTER = LuSnowflake;
export const MILESTONE = TbFlag3;
export const DEADLINE = TbClockExclamation;
export const SCHEDULE = MdOutlineSchedule;
export const WEEKEND = MdOutlineWeekend;
export const BIRTHDAY_CAKE = PiCake;

// DOCUMENTS & DATA
export const FILE_TEXT = BsFileEarmarkText;
export const FILE_CHECK = BsFileEarmarkCheck;
export const FILE_LOCK = BsFileEarmarkLock;
export const FILE_MEDICAL = BsFileEarmarkMedical;
export const FILE_PERSON = BsFileEarmarkPerson;
export const FILE_CODE = BsFileEarmarkCode;
export const FILE_MUSIC = BsFileEarmarkMusic;
export const FILE_PLAY = BsFileEarmarkPlay;
export const FILE_SPREADSHEET = BsFileEarmarkSpreadsheet;
export const FILE_SLIDES = BsFileEarmarkSlides;
export const FILE_RULED = BsFileEarmarkRuled;
export const FILE_BAR_GRAPH = BsFileEarmarkBarGraph;
export const FILE_BINARY = BsFileEarmarkBinary;
export const FILE_FONT = BsFileEarmarkFont;
export const FILES = BsFiles;
export const FOLDER_OPEN = BsFolder2Open;
export const FOLDER_PLUS = BsFolderPlus;
export const FOLDER_CHECK = BsFolderCheck;
export const FOLDERS = TbFolders;
export const ARCHIVE_2 = TbArchive;
export const JOURNAL_TEXT = BsJournalText;
export const JOURNAL_CHECK = BsJournalCheck;
export const JOURNAL_BOOKMARK = BsJournalBookmark;
export const JOURNAL_MEDICAL = BsJournalMedical;
export const JOURNAL_RICHTEXT = BsJournalRichtext;
export const CLIPBOARD_LIST = TbClipboardList;
export const CLIPBOARD_TEXT = TbClipboardText;
export const NOTES = TbNotes;
export const NOTE = PiNote;
export const NOTEPAD = PiNotepad;
export const CARD_LIST = BsCardList;
export const CARD_HEADING = BsCardHeading;
export const TABLE_2 = TbTable;
export const DATABASE_2 = TbDatabase;
export const SERVER_2 = TbServer2;
export const STACK_2 = TbStack2;
export const LAYERS = TbStack3;
export const CATEGORY = TbCategory;
export const CATEGORY_2 = TbCategory2;
export const LIST_DETAILS = TbListDetails;
export const LIST_NUMBERS = TbListNumbers;
export const LIST_TREE = TbListTree;
export const LIST_NESTED = BsListNested;
export const LIST_STARS = BsListStars;
export const UI_CHECKS = BsUiChecks;
export const UI_RADIOS = BsUiRadios;
export const INPUT_CURSOR = BsInputCursorText;
export const SEGMENTED = BsSegmentedNav;
export const GRID = BsGrid;
export const GRID_3X3 = BsGrid3X3Gap;
export const COLUMNS = BsColumnsGap;
export const WINDOW_STACK = BsWindowStack;
export const TERMINAL_2 = TbTerminal2;
export const BRACES_2 = TbBraces;
export const BARCODE_2 = BsUpc;
export const QR_SCAN = BsQrCodeScan;
export const FINGERPRINT_2 = TbFingerprint;
export const HASH_2 = TbHash;
export const VERSION = TbVersions;
export const FILE_DIFF = TbFileDiff;
export const FILE_IMPORT = TbFileImport;
export const FILE_EXPORT = TbFileExport;
export const DATABASE_EXPORT = TbDatabaseExport;
export const DATABASE_IMPORT = TbDatabaseImport;
export const CLOUD_DATA = TbCloudDataConnection;
export const API = TbApi;
export const WEBHOOK = TbWebhook;
export const AUTOMATION = TbSettingsAutomation;
export const FORM = TbForms;
export const SURVEY = MdOutlinePoll;
export const CHECKLIST_2 = TbChecklist;
export const TIMELINE = TbTimeline;
export const FLOWCHART = TbGitBranch;
export const MINDMAP = TbSitemap;
export const PROGRESS = TbProgress;
export const GAUGE_2 = TbGaugeFilled;
export const RANKING = TbTrophy;
export const STAR_HALF = BsStarHalf;
export const SCALE_RATING = MdOutlineLinearScale;

// SYMBOLS & SHAPES
export const CIRCLE = BsCircle;
export const CIRCLE_FILL = BsCircleFill;
export const CIRCLE_HALF = BsCircleHalf;
export const SQUARE = BsSquare;
export const SQUARE_FILL = BsSquareFill;
export const TRIANGLE = BsTriangle;
export const DIAMOND_SHAPE = BsDiamond;
export const HEXAGON = BsHexagon;
export const PENTAGON = BsPentagon;
export const OCTAGON = BsOctagon;
export const HEPTAGON = BsHeptagon;
export const STAR_OUTLINE = BsStar;
export const STAR_FILL = BsStarFill;
export const HEART_FILL = BsHeartFill;
export const HEART_HALF = BsHeartHalf;
export const HEARTS = BsHearts;
export const HEARTBREAK = BsHeartbreak;
export const PLUS_CIRCLE = BsPlusCircle;
export const DASH_CIRCLE = BsDashCircle;
export const X_CIRCLE = BsXCircle;
export const QUESTION_CIRCLE = BsQuestionCircle;
export const QUESTION_DIAMOND = BsQuestionDiamond;
export const EXCLAMATION_TRIANGLE = BsExclamationTriangle;
export const EXCLAMATION_DIAMOND = BsExclamationDiamond;
export const INFO_SQUARE = BsInfoSquare;
export const CHECK_SQUARE = BsCheckSquare;
export const CHECK_ALL = BsCheckAll;
export const SLASH_CIRCLE = BsSlashCircle;
export const DOT = BsDot;
export const THREE_DOTS = BsThreeDots;
export const ARROW_UP = BsArrowUp;
export const ARROW_DOWN = BsArrowDown;
export const ARROW_LEFT = BsArrowLeft;
export const ARROW_RIGHT = BsArrowRight;
export const ARROW_UP_RIGHT = BsArrowUpRight;
export const ARROW_DOWN_RIGHT = BsArrowDownRight;
export const ARROW_REPEAT = BsArrowRepeat;
export const ARROW_CLOCKWISE = BsArrowClockwise;
export const ARROW_COUNTERCLOCKWISE = BsArrowCounterclockwise;
export const ARROWS_EXPAND = BsArrowsFullscreen;
export const ARROWS_COLLAPSE = BsArrowsCollapse;
export const ARROWS_MOVE = BsArrowsMove;
export const SHUFFLE_2 = TbArrowsShuffle;
export const BOX_ARROW_IN = BsBoxArrowInRight;
export const BOX_ARROW_OUT = BsBoxArrowRight;
export const INTERSECT = BsIntersect;
export const UNION = BsUnion;
export const BOUNDING_BOX = BsBoundingBox;
export const LAYERS_2 = BsLayers;
export const NODE_PLUS = BsNodePlus;
export const SYMMETRY = BsSymmetryVertical;
export const TRANSPARENCY = BsTransparency;
export const PATCH_CHECK = BsPatchCheck;
export const PATCH_EXCLAMATION = BsPatchExclamation;
export const PATCH_QUESTION = BsPatchQuestion;
export const PATCH_PLUS = BsPatchPlus;
export const BADGE_AD = BsBadgeAd;
export const BADGE_HD = BsBadgeHd;
export const BADGE_4K = BsBadge4K;
export const BADGE_VR = BsBadgeVr;
export const BADGE_WC = BsBadgeWc;
export const BADGE_TM = BsBadgeTm;
export const COPYRIGHT = BsCCircle;
export const REGISTERED = BsRCircle;
export const PARKING_P = BsPCircle;
export const LETTER_H = BsHCircle;
export const CURRENCY = TbCurrency;
export const CENT = TbCurrencyCent;
export const NUMBER_SIGN = TbNumber;
export const NUMBER_0 = TbNumber0;
export const NUMBER_1 = TbNumber1;
export const NUMBER_2 = TbNumber2;
export const NUMBER_3 = TbNumber3;
export const NUMBER_4 = TbNumber4;
export const NUMBER_5 = TbNumber5;
export const NUMBER_6 = TbNumber6;
export const NUMBER_7 = TbNumber7;
export const NUMBER_8 = TbNumber8;
export const NUMBER_9 = TbNumber9;
export const SQUARE_0 = Bs0Square;
export const SQUARE_1 = Bs1Square;
export const SQUARE_2 = Bs2Square;
export const SQUARE_3 = Bs3Square;
export const SQUARE_4 = Bs4Square;
export const SQUARE_5 = Bs5Square;
export const SQUARE_6 = Bs6Square;
export const SQUARE_7 = Bs7Square;
export const SQUARE_8 = Bs8Square;
export const SQUARE_9 = Bs9Square;
export const LETTER_A = TbLetterA;
export const LETTER_B = TbLetterB;
export const LETTER_C = TbLetterC;
export const LETTER_D = TbLetterD;
export const LETTER_E = TbLetterE;
export const LETTER_F = TbLetterF;
export const LETTER_X = TbLetterX;
export const LETTER_Z = TbLetterZ;
export const ROMAN_I = TbRosetteNumber1;
export const ROMAN_II = TbRosetteNumber2;
export const ROMAN_III = TbRosetteNumber3;
export const ALPHA = TbAlpha;
export const BETA = TbBeta;
export const OMEGA = TbOmega;
export const SIGMA = TbSum;
export const PLUS_MINUS = TbPlusMinus;
export const EQUAL = TbEqual;
export const NOT_EQUAL = TbEqualNot;
export const DIVIDE = TbDivide;
export const MULTIPLY = TbX;
export const CIRCLE_DOTTED = TbCircleDotted;
export const CIRCLE_DASHED = TbCircleDashed;
export const SQUARE_DASHED = LuSquareDashedBottom;
export const STAR_DASHED = TbStarOff;
export const SPARKLES = LuSparkles;
export const WAND = BsMagic;
export const LIGHTNING_FILL = BsLightningFill;
export const FIRE_2 = TbFlame;
export const SNOW_2 = BsSnow2;
export const DROPLET_HALF = BsDropletHalf;
export const MOISTURE = BsMoisture;
export const BRIGHTNESS = BsBrightnessHigh;
export const BRIGHTNESS_LOW = BsBrightnessLow;
export const EMOJI_SMILE = BsEmojiSmile;
export const EMOJI_LAUGHING = BsEmojiLaughing;
export const EMOJI_HEART_EYES = BsEmojiHeartEyes;
export const EMOJI_SUNGLASSES = BsEmojiSunglasses;
export const EMOJI_WINK = BsEmojiWink;
export const EMOJI_NEUTRAL = BsEmojiNeutral;
export const EMOJI_FROWN = BsEmojiFrown;
export const EMOJI_ANGRY = BsEmojiAngry;
export const EMOJI_DIZZY = BsEmojiDizzy;
export const EMOJI_EXPRESSIONLESS = BsEmojiExpressionless;
export const EMOJI_TEAR = BsEmojiTear;
export const EMOJI_SURPRISE = BsEmojiSurprise;
export const EMOJI_KISS = BsEmojiKiss;
export const EMOJI_GRIN = BsEmojiGrin;
export const EMOJI_ASTONISHED = BsEmojiAstonished;
export const EMOJI_GRIMACE = BsEmojiGrimace;
export const HAND_INDEX = BsHandIndex;
export const HAND_THUMBS_UP_FILL = BsHandThumbsUpFill;
export const HAND_FIST = PiHandFist;
export const HAND_PALM = PiHandPalm;
export const PERSON_ARMS_SPREAD = PiPersonArmsSpread;
export const UNIVERSAL_ACCESS = BsUniversalAccess;
export const EJECT = BsEject;
export const ALT = BsAlt;
export const SHIFT = BsShift;
export const ESCAPE = BsEscape;
export const OPTION = BsOption;
export const CAPSLOCK = BsCapslock;
export const REGEX = BsRegex;
export const VIGNETTE = BsVignette;
export const HYPNOTIZE = BsHypnotize;
export const NOISE = BsNoiseReduction;
export const ASPECT_RATIO = BsAspectRatio;
export const BEZIER = BsBezier2;
export const BRILLIANCE = BsBrilliance;
export const SHADOWS = BsShadows;

// WEAPONS & MILITARY
export const BOW_ARROW_2 = GiBowArrow;
export const CROSSBOW = GiCrossbow;
export const SPEAR = GiSpears;
export const SHIELD_MEDIEVAL_2 = GiRoundShield;
export const HELMET_KNIGHT = GiVisoredHelm;
export const ARMOR = GiChestArmor;
export const TANK = GiTank;
export const JET = GiJetFighter;
export const SUBMARINE = GiSubmarine;
export const BATTLESHIP = GiBattleship;
export const MEDAL_MILITARY = GiMedal;
export const RANK = GiRank3;
export const GRENADE = GiGrenade;
export const BULLET = GiBullets;
export const TARGET_SHOOTING = GiTargetShot;
export const RADAR_MILITARY = GiRadarSweep;
export const PARACHUTE = GiParachute;
export const MISSILE = GiMissileSwarm;
export const BUNKER = GiBunker;
export const WALKIE_TALKIE = GiWalkieTalkie;
export const FLAG_MILITARY = GiFlyingFlag;
export const KATANA = GiKatana;
export const AXE_BATTLE = GiBattleAxe;
export const MACE = GiMaceHead;
export const HAMMER_WAR = GiWarhammer;
export const REVOLVER = GiRevolver;
export const RIFLE = GiRifle;
export const MUSKET = GiMusket;
export const CATAPULT = GiCatapult;
export const CANNON_BALL = GiCannonBall;
export const CASTLE_2 = GiCastle;
export const BARRACKS = GiBarracks;
export const SERGEANT = GiSergeant;
export const HALBERD = GiHalberd;
export const DAGGERS = GiDaggers;
export const ARMOR_VEST = GiArmorVest;
export const JETPACK = GiJetPack;
export const MISSILE_LAUNCHER = GiMissileLauncher;
export const RADAR_DISH = GiRadarDish;
export const RANK_1 = GiRank1;
export const RANK_2 = GiRank2;
export const SHIELD_BASH = GiShieldBash;

// AGRICULTURE & FARMING
export const SILO = GiWheat;
export const PLOW = GiPlow;
export const SCYTHE = GiScythe;
export const FARMER = GiFarmer;
export const BEEHIVE = GiBeehive;
export const GREENHOUSE = GiGreenhouse;
export const CORN = GiCorn;
export const CORNUCOPIA = GiCornucopia;
export const FERTILIZER = GiFertilizerBag;
export const FIELD = GiField;
export const WATER_MILL = GiWaterMill;
export const WINDMILL_2 = GiWindmill;
export const GARDEN_CART = TbGardenCart;
export const EGGS = TbEggs;
export const SEEDLING_2 = GiSeedling;
export const GRAPES_2 = GiGrapes;
export const VINEYARD = GiVineFlower;
export const ORCHARD = GiFruitTree;
export const ROOSTER = GiRooster;
export const BULL = GiBull;
export const DONKEY = GiDonkey;
export const MILK_CARTON = GiMilkCarton;
export const HONEY = GiHoneyJar;
export const SHOVEL_2 = GiSpade;
export const RAKE = GiRake;
export const PITCHFORK = GiPitchfork;
export const IRRIGATION = GiWaterDrop;
export const TREE_STUMP = GiLog;
export const GOOSE = GiGoose;
export const BOAR = GiBoar;
export const RAM = GiRam;
export const PIG_FACE = GiPigFace;
export const CABBAGE = GiCabbage;
export const POTATO = GiPotato;
export const TOMATO = GiTomato;
export const PUMPKIN_2 = GiPumpkin;
export const PEAR = GiPear;
export const HONEYCOMB = GiHoneycomb;
export const SICKLE = GiSickle;
export const EGG_CLUTCH = GiEggClutch;
export const VINE_LEAF = GiVineLeaf;
export const TREE_GROWTH = GiTreeGrowth;
export const WOOD_PILE = GiWoodPile;
export const WOODEN_FENCE = GiWoodenFence;
export const WOODEN_CRATE = GiWoodenCrate;
export const HORSE_HEAD = GiHorseHead;

// LOGISTICS & SHIPPING
export const PALLET = GiCardboardBox;
export const SHIPPING_CONTAINER = GiCargoCrate;
export const CARGO_SHIP = GiCargoShip;
export const CRANE_CARGO = GiCargoCrane;
export const FORKLIFT_2 = GiForklift;
export const TRUCK_LOADING = TbTruckLoading;
export const TRUCK_RETURN = TbTruckReturn;
export const TRUCK_OFF = TbTruckOff;
export const PACKAGE_EXPORT = TbPackageExport;
export const PACKAGE_IMPORT = TbPackageImport;
export const PACKAGE_OFF = TbPackageOff;
export const BOX_MULTIPLE = TbBoxMultiple;
export const BOX_SEAM_2 = TbBoxSeam;
export const BOX_OFF = TbBoxOff;
export const ROUTE_2 = TbRoute;
export const PLANE_CARGO = TbPlane;
export const TRAIN_2 = TbTrain;
export const SCALE_WEIGHT_2 = TbWeight;
export const DIMENSIONS = TbDimensions;
export const QR_CODE_2 = TbQrcode;
export const TRACKING = TbMapPinSearch;
export const DELIVERY_TIME = TbClockShield;
export const FRAGILE = TbGlass;
export const HAND_TRUCK = LiaDollySolid;
export const LOAD = TbLoader;
export const HAND_TRUCK_2 = GiHandTruck;
export const CARDBOARD_BOXES = TbCardboards;
export const CONVEYOR_2 = MdConveyorBelt;
export const FACTORY_2 = TbBuildingFactory;
export const BOX_2 = TbBox;
export const BOX_MULTIPLE_1 = TbBoxMultiple1;
export const CHECKUP_LIST = TbCheckupList;
export const E_PASSPORT = TbEPassport;
export const PAPER_BOAT = GiPaperBoat;

// REAL ESTATE & PROPERTY
export const HOUSE_FOR_SALE = TbHomeDollar;
export const HOUSE_CHECK = TbHomeCheck;
export const HOUSE_SEARCH = TbHomeSearch;
export const HOUSE_STATS = TbHomeStats;
export const HOUSE_EDIT = TbHomeEdit;
export const HOUSE_PLUS = TbHomePlus;
export const HOUSE_MOVE = TbHomeMove;
export const HOUSE_SHIELD = TbHomeShield;
export const HOUSE_BOLT = TbHomeBolt;
export const HOUSE_HAND = TbHomeHand;
export const HOUSE_LINK = TbHomeLink;
export const HOUSE_2 = TbHome2;
export const HOUSE_ECO = TbHomeEco;
export const HOUSE_SIGNAL = TbHomeSignal;
export const HOUSE_QUESTION = TbHomeQuestion;
export const HOUSE_COG = TbHomeCog;
export const HOUSE_HEART_2 = TbHomeHeart;
export const HOUSE_OFF = TbHomeOff;
export const BUILDING_2 = TbBuilding;
export const FLOOR_PLAN = TbLayoutBoard;
export const LAND_PLOT = TbMap;
export const GARAGE_2 = TbCarGarage;
export const ELEVATOR = TbElevator;
export const STAIRS = TbStairs;
export const ROOF = TbHomeInfinity;
export const BATH = TbBath;
export const DOOR_2 = TbDoor;

// LEGAL & GOVERNMENT
export const LICENSE = TbLicense;
export const CONTRACT_2 = TbFileCertificate;
export const SIGNATURE = TbSignature;
export const STAMP_2 = TbRubberStamp;
export const SEAL = TbRosette;
export const BALLOT = TbCheckbox;
export const FLAG_2 = TbFlag;
export const POLICE_CAR = TbCar;
export const PRISON = GiPrisoner;
export const LAW_BOOK = TbBook2;
export const BRIEFCASE_LAW = TbBriefcase;
export const ID_BADGE_2 = TbIdBadge2;
export const COPYRIGHT_2 = TbCopyright;
export const TRADEMARK = TbTrademark;
export const REGISTERED_2 = TbRegistered;
export const CREATIVE_COMMONS = TbCreativeCommons;
export const PRIVACY = TbEyeOff;
export const COMPLIANCE = TbClipboardCheck;
export const EVIDENCE = TbFolderSearch;
export const WITNESS = TbUserQuestion;
export const FINE = TbReceipt2;
export const SHIELD_LAW = TbShieldCheck;

// ENERGY & UTILITIES
export const BOLT = TbBolt;
export const BOLT_OFF = TbBoltOff;
export const PLUG_2 = TbPlug;
export const PLUG_CONNECTED = TbPlugConnected;
export const CHARGING_PILE = TbChargingPile;
export const BATTERY_ECO = TbBatteryEco;
export const BATTERY_4 = TbBattery4;
export const BATTERY_1 = TbBattery1;
export const SOLAR_2 = TbSolarPanel2;
export const SOLAR_ELECTRICITY = TbSolarElectricity;
export const WIND_ELECTRICITY = TbWindElectricity;
export const NUCLEAR = TbRadioactive;
export const ATOM_2 = TbAtom2;
export const GAS_STATION_2 = TbGasStation;
export const PROPANE = MdOutlinePropaneTank;
export const OIL_BARREL = TbBarrel;
export const WATER_TAP = TbDroplet;
export const SMART_METER = TbDeviceAnalytics;
export const THERMOSTAT = TbTemperaturePlus;
export const AIR_CONDITIONER = TbAirConditioning;
export const LIGHT_BULB_2 = TbBulb;
export const LIGHT_BULB_OFF_2 = TbBulbOff;
export const CIRCUIT = TbCircuitBulb;
export const VOLTAGE = TbCircuitVoltmeter;
export const FUSE = TbCircuitSwitchOpen;
export const TRASH_BIN = TbTrash;
export const RECYCLE_2 = TbRecycle;
export const CARBON = TbCloudComputing;
export const WORLD_ECO = TbWorld;

// CRAFTS & SEWING
export const NEEDLE = TbNeedle;
export const SCISSORS_2 = TbScissors;
export const SEWING_NEEDLE = GiSewingNeedle;
export const BUTTON = GiShirtButton;
export const ZIPPER = GiZipper;
export const FABRIC = GiRolledCloth;
export const LOOM = GiPaperClip;
export const PAINT_PALETTE = TbPalette;
export const BRUSH_2 = TbBrush;
export const POTTERY_2 = GiAmphora;
export const WOODWORKING = GiWoodBeam;
export const CHISEL = GiChisel;
export const SANDPAPER = GiSandsOfTime;
export const BEADS = GiPearlNecklace;
export const RIBBON = GiRibbonShield;
export const STICKER = TbSticker;
export const CUTTER = TbCut;
export const PENCIL_2 = TbPencil;
export const QUILT = MdOutlineViewQuilt;
export const LEATHER = GiLeatherBoot;
export const CANDLE_3 = TbCandle;
export const CHISEL_2 = TbChisel;
export const COLOR_SWATCH = TbColorSwatch;
export const COLOR_PICKER = TbColorPicker;
export const HAMMER_2 = TbHammer;
export const NUT = TbNut;
export const PIN_2 = TbPin;
export const RULER_3 = TbRuler3;
export const WOOD = TbWood;
export const ZIP = TbZip;
export const PENCIL_BRUSH = GiPencilBrush;
export const PENCIL_RULER_2 = GiPencilRuler;
export const PENCIL_3 = GiPencil;
export const EASEL_2 = GiEasel;
export const PAINT_ROLLER_2 = GiPaintRoller;
export const PAINT_BUCKET_2 = GiPaintBucket;
export const PAINT_BRUSH_3 = GiPaintBrush;
export const PALETTE_2 = GiPalette;
export const STAPLER_2 = GiStaplerHeavyDuty;
export const NECKLACE_2 = GiNecklace;
export const EARRINGS_2 = GiEarrings;
export const CLAY_BRICK = GiClayBrick;
export const CLOTH_JAR = GiClothJar;

// BEAUTY & WELLNESS
export const SCISSORS_HAIR = GiScissors;
export const SAUNA = GiSteam;
export const BATHTUB_2 = GiBathtub;
export const SOAP_2 = GiSoap;
export const SUNSCREEN = GiSunflower;
export const TOOTHPASTE = GiTooth;
export const MEDITATION_2 = GiMeditation;
export const AROMATHERAPY = GiIncense;
export const FACE_MASK = GiDuality;
export const BEARD = GiBeard;
export const MUSTACHE = GiMustache;
export const LIPS = GiLips;
export const EYELASHES = GiEyelashes;
export const FACE_POWDER = GiPowder;
export const RAZOR_BLADE = GiRazorBlade;
export const SLEEPY = GiSleepy;
export const SPARKLE_FACE = GiSparkles;
export const BATHTUB_3 = LuBath;
export const FACE = MdOutlineFace;
export const SALON_CHAIR = GiRockingChair;
export const SPA_TOWEL = GiClothes;
export const SCALPEL = GiScalpel;

// KIDS & SCHOOL
export const PENCIL_RULER = TbRuler2;
export const ABC = TbAbc;
export const NUMBERS_123 = TbNumbers;
export const TEDDY_BEAR_2 = GiBearFace;
export const RATTLE = GiBabyBottle;
export const PACIFIER = GiBabyFace;
export const HIGH_CHAIR = PiChair;
export const SANDBOX = GiSandCastle;
export const BALLOON_2 = TbBalloon;
export const SCHOOL_BUS = TbBus;
export const CHALKBOARD_2 = TbChalkboard;
export const REPORT_CARD = TbReportAnalytics;
export const FAMILY = MdOutlineFamilyRestroom;
export const SCHOOL_BAG = GiSchoolBag;
export const BALLOONS = GiBalloons;
export const BALLOON_DOG = GiBalloonDog;
export const TOY_MALLET = GiToyMallet;
export const JIGSAW = GiPuzzle;
export const DICE_ONE = TbDice1;
export const DICE_SIX = TbDice6;
export const ICE_CREAM_2 = TbIceCream2;
export const BOY_2 = TbMoodBoy;
export const CRAZY_HAPPY = TbMoodCrazyHappy;
export const BALLPEN = TbBallpen;
export const BABY_2 = LuBaby;
export const CANDY_2 = LuCandy;
export const CAKE_SLICE_2 = LuCakeSlice;
export const SINGING = TbMoodSing;
export const BALLET = GiBallerinaShoes;
export const PAINT_CAN = TbPaint;
export const BOOK_STACK = LuBookCopy;

// MAPS & NAVIGATION
export const MAP_PIN_CHECK = TbMapPinCheck;
export const MAP_PIN_OFF = TbMapPinOff;
export const MAP_PIN_HEART = TbMapPinHeart;
export const MAP_PIN_STAR = TbMapPinStar;
export const MAP_PIN_PLUS = TbMapPinPlus;
export const MAP_PIN_PIN = TbMapPinPin;
export const COMPASS_2 = TbCompass;
export const GPS = TbGps;
export const CURRENT_LOCATION = TbCurrentLocation;
export const LOCATION_2 = TbLocation;
export const ROUTE_3 = TbRoute2;
export const ROAD = TbRoad;
export const ROAD_SIGN = TbRoadSign;
export const SIGNPOST_2 = TbSignRight;
export const WORLD_MAP = TbWorldLatitude;
export const LONGITUDE = TbWorldLongitude;
export const SATELLITE_2 = TbSatellite;
export const RADAR_2 = TbRadar2;
export const ZOOM_IN_AREA = TbZoomInArea;
export const ZOOM_OUT_AREA = TbZoomOutArea;
export const MAP_SEARCH = TbMapSearch;
export const TOPOGRAPHY = TbTopologyStar;
export const PARKING_2 = TbParking;
export const BUS_STOP = TbBusStop;
export const TRAFFIC_LIGHTS = TbTrafficLights;
export const TRAFFIC_CONE = TbTrafficCone;
export const DIRECTION_ARROWS = TbArrowsMove;

// BOOKS & WRITING
export const BOOK_2 = TbBook;
export const BOOKMARK_2 = TbBookmark;
export const BOOKMARKS = TbBookmarks;
export const NOVEL = GiBookCover;
export const STACK_OF_BOOKS = GiBookPile;
export const OPEN_BOOK_2 = GiOpenBook;
export const MANUSCRIPT = TbFileText;
export const NOTEBOOK_2 = PiNotebook;
export const DICTIONARY = TbVocabulary;
export const CHAPTER = TbSection;
export const POEM = TbFeather;
export const LETTER = TbMail;
export const NEWSPAPER_2 = TbNews;
export const MAGAZINE = TbBookDownload;
export const E_READER = TbDeviceTablet;
export const AUDIOBOOK = TbHeadphones;
export const HIGHLIGHT = TbHighlight;
export const QUOTE_2 = TbQuote;
export const BOOKMARK_3 = GiBookmark;
export const ENVELOPE_2 = GiEnvelope;
export const INK = GiInkSwirl;
export const MAILBOX_3 = GiMailbox;
export const NEWSPAPER_3 = GiNewspaper;
export const NOTEBOOK_3 = GiNotebook;
export const PAPER = BsFileEarmark;
export const PAPERS = GiPapers;
export const PAPER_PLANE = GiPaperPlane;
export const PAPER_TRAY = GiPaperTray;
export const QUILL_2 = GiQuill;
export const TALK = GiTalk;
export const BLACK_BOOK = GiBlackBook;
export const BOOK_3 = LuBook;
export const BOOK_OPEN_3 = LuBookOpen;
export const BOOK_MARKED = LuBookMarked;
export const BOOK_KEY = LuBookKey;
export const BOOK_LOCK = LuBookLock;
export const BOOK_TEMPLATE = LuBookTemplate;
export const FEATHER_2 = LuFeather;
export const LIBRARY_BOOKS = MdOutlineLibraryBooks;
export const ARTICLE = MdOutlineArticle;
export const STICKY_NOTE_2 = MdOutlineStickyNote2;
export const DRAW = MdOutlineDraw;

// AUTOMOTIVE & GARAGE
export const CAR_SUV = TbCarSuv;
export const CAR_CRANE = TbCarCrane;
export const CAR_TURBINE = TbCarTurbine;
export const CAR_OFF = TbCarOff;
export const STEERING_WHEEL_2 = TbSteeringWheel;
export const AUTOMATIC_GEARBOX = TbAutomaticGearbox;
export const TIRE_2 = GiFlatTire;
export const BRAKE = TbDisc;
export const OIL_CHANGE = TbDropletHalf2;
export const SPEEDOMETER_2 = TbDashboard;
export const AIRBAG = TbShieldHalf;
export const WINDSHIELD = TbWiperWash;
export const MECHANIC = TbTool;
export const CARAVAN_2 = TbCaravan;
export const CRASH = TbCarCrash;
export const WHEEL_2 = TbWheel;
export const WIPER = TbWiper;
export const HELMET_MOTO = TbHelmet;
export const E_SCOOTER = TbScooterElectric;
export const SPEEDBOAT = TbSpeedboat;
export const BICYCLE_2 = TbBike;
export const BATTERY_2 = TbBattery;
export const BATTERY_CHARGING_2 = TbBatteryCharging;
export const TOOLS_2 = TbTools;
export const SPARK_PLUG = GiSparkPlug;
export const CAR_DOOR = GiCarDoor;
export const CAR_KEY_2 = GiCarKey;
export const CAR_BATTERY_2 = GiCarBattery;
export const CAR_SEAT = GiCarSeat;
export const GAS_PUMP = GiGasPump;
export const JERRYCAN = GiJerrycan;
export const TOW_TRUCK = GiTowTruck;
export const MECHANIC_GARAGE = GiMechanicGarage;
export const TIRE_IRON = GiTireIron;
export const RACE_CAR = GiRaceCar;
export const F1_CAR = GiF1Car;
export const JEEP_2 = GiJeep;
export const CITY_CAR = GiCityCar;
export const SCOOTER_2 = GiScooter;
export const BUS_3 = GiBus;
export const BUS_STOP_2 = GiBusStop;
export const SPEEDOMETER_3 = GiSpeedometer;
export const COG = GiCog;

// SPACE & ASTRONOMY
export const ROCKET_2 = TbRocket;
export const MOON_2 = TbMoon;
export const SUN_2 = TbSun;
export const STAR_2 = TbStar;
export const GALAXY = TbGalaxy;
export const METEOR = TbMeteor;
export const COMET = TbComet;
export const ASTRONAUT = GiAstronautHelmet;
export const SPACE_SHUTTLE = GiSpaceShuttle;
export const ALIEN = TbAlien;
export const UNIVERSE = TbUniverse;
export const EARTH = GiEarthAmerica;
export const SOLAR_SYSTEM = GiSolarSystem;
export const BLACK_HOLE = GiBlackHoleBolas;
export const OBSERVATORY = GiObservatory;
export const MOON_PHASES = TbMoon2;
export const SPACE_STATION = GiSpaceship;
export const LAUNCH_PAD = GiRocketThruster;
export const ASTEROID = GiAsteroid;
export const GALAXY_2 = GiGalaxy;
export const JUPITER = GiJupiter;
export const LUNAR_MODULE = GiLunarModule;
export const MARS_ROVER = GiMarsCuriosity;
export const METEOR_IMPACT = GiMeteorImpact;
export const MOON_ORBIT = GiMoonOrbit;
export const MOON_3 = GiMoon;
export const ORBIT_3 = GiOrbit;
export const ORBITAL = GiOrbital;
export const PLANET_CORE = GiPlanetCore;
export const ROCKET_FLIGHT = GiRocketFlight;
export const ROCKET_3 = GiRocket;
export const SATELLITE_DISH = GiSatelliteCommunication;
export const SPACE_SUIT = GiSpaceSuit;
export const STAR_FORMATION = GiStarFormation;
export const STARS_STACK = GiStarsStack;
export const UFO_3 = GiUfo;
export const COMET_2 = GiCometSpark;
export const EARTH_AFRICA = GiEarthAfricaEurope;
export const EARTH_ASIA = GiEarthAsiaOceania;
export const SOLAR_POWER_2 = GiSolarPower;
export const ROCKET_LAUNCH = MdOutlineRocketLaunch;
export const SATELLITE_3 = MdOutlineSatelliteAlt;

// EMERGENCY & RESCUE
export const ALERT_OCTAGON = TbAlertOctagon;
export const ALERT_CIRCLE = TbAlertCircle;
export const ALERT_SQUARE = TbAlertSquare;
export const URGENT = TbUrgent;
export const EVACUATION = TbDoorExit;
export const SMOKE_DETECTOR = GiSmokeBomb;
export const FLOOD = TbRipple;
export const HAZARD = TbBiohazard;
export const POISON = GiPoisonBottle;
export const COAST_GUARD = GiLifeJacket;
export const ROPE = GiRopeCoil;
export const EMERGENCY_PHONE = TbPhoneCall;
export const AMBULANCE_3 = GiAmbulance;
export const FIRE_EXTINGUISHER_3 = GiFireExtinguisher;
export const EXIT_DOOR = GiExitDoor;
export const FLOOD_2 = GiFlood;
export const HAZARD_SIGN = GiHazardSign;
export const HELMET_2 = GiHelmet;
export const LIFE_BUOY = GiLifeBuoy;
export const LIFE_SUPPORT = GiLifeSupport;
export const MEDICAL_DRIP = GiMedicalDrip;
export const MEDICAL_PACK = GiMedicalPack;
export const POISON_2 = GiPoison;
export const RADIATION = GiRadiations;
export const TORNADO_2 = GiTornado;
export const ROPE_BRIDGE = GiRopeBridge;
export const FIRE_AXE = GiFireAxe;
export const BANDAGE_ROLL = GiBandageRoll;
export const ALARM_CLOCK = GiAlarmClock;

// OUTDOORS & CAMPING
export const BINOCULARS_2 = GiBinoculars;
export const COMPASS_3 = GiCompass;
export const KAYAK_2 = TbKayak;
export const LANTERN = GiLantern;
export const CLIMBING = GiMountainClimbing;
export const CARABINER = GiCarabiner;
export const WATER_BOTTLE = GiWaterFlask;
export const PINE_TREE = PiTreeEvergreen;
export const PICNIC = TbBasket;
export const STARGAZING = TbMoonStars;
export const NATIONAL_PARK = GiPineTree;
export const CAMPFIRE_3 = GiCampfire;
export const CAMP_COOKING = GiCampCookingPot;
export const FOREST_CAMP = GiForestCamp;
export const FOREST_2 = GiForest;
export const MOUNTAINS = GiMountains;
export const MOUNTAIN_ROAD = GiMountainRoad;
export const MOUNTAIN_CAVE = GiMountainCave;
export const RAFT = GiRaft;
export const RIVER = GiRiver;
export const FISHING_NET = GiFishingNet;
export const FISHING_LURE = GiFishingLure;
export const FISHING_BOAT = GiFishingBoat;
export const BOOTS_2 = GiBoots;
export const BOOT_PRINTS = GiBootPrints;
export const SKI_BOOT = GiSkiBoot;
export const SKIER = GiSkier;
export const SUN_CLOUD = GiSunCloud;
export const SUNDIAL = GiSundial;
export const LANTERN_FLAME = GiLanternFlame;
export const AXE_STUMP = GiAxeInStump;
export const BEACH_BALL = GiBeachBall;
export const BEACH_BUCKET = GiBeachBucket;
export const PADDLES = GiPaddles;
export const PATH_DISTANCE = GiPathDistance;
export const CLIFF_CROSSING = GiCliffCrossing;
export const SLEEPING_BAG_2 = GiSleepingBag;
export const BACKPACK_3 = GiBackpack;
export const KAYAK_3 = GiWoodCanoe;

// AWARDS & ACHIEVEMENTS
export const AWARD_2 = TbAward;
export const STAR_FILLED = TbStarFilled;
export const STARS_2 = TbStars;
export const BADGE = TbBadge;
export const BADGES = TbBadges;
export const PODIUM = TbPodium;
export const LAUREL = GiLaurelCrown;
export const LAURELS = GiLaurels;
export const RIBBON_MEDAL = GiRibbonMedal;
export const CUP_2 = GiTrophyCup;
export const GOLD_BAR = GiGoldBar;
export const TARGET_2 = TbTarget;
export const THUMBS_UP = TbThumbUp;
export const PREMIUM = TbPremiumRights;
export const SEAL_CHECK = TbDiscountCheck;
export const HALL_OF_FAME = GiPodium;

// CHARITY & COMMUNITY
export const CARE = TbHeart;
export const ACCESSIBILITY = TbAccessible;
export const PEACE_2 = TbPeace;
export const WORLD_HEART = TbWorldHeart;
export const SOCIAL = TbSocial;
export const MEMBERSHIP = TbUserCheck;
export const NEW_MEMBER = TbUserPlus;
export const SPEAKER_2 = TbSpeakerphone;
export const PETITION = TbWriting;
export const GRANT = TbCoin;
export const HELP = GiHelp;
export const SHARE_2 = GiShare;
export const RECEIVE_MONEY = GiReceiveMoney;
export const MONEY_STACK = GiMoneyStack;
export const PEACE_DOVE = GiPeaceDove;
export const AWARENESS_RIBBON = GiRibbon;
export const FAMILY_HOUSE = GiFamilyHouse;
export const FAMILY_TREE = GiFamilyTree;
export const TEAM_IDEA = GiTeamIdea;
export const TEAM_GROWTH = GiTeamUpgrade;
export const MEAL_2 = GiMeal;
export const HUMAN_PYRAMID = GiHumanPyramid;
export const HEART_INSIDE = GiHeartInside;
export const HEART_WINGS = GiHeartWings;
export const BLOOD_DROP_2 = GiBlood;
export const HAND_OK = GiHandOk;
export const COINS_PILE = GiCoinsPile;
export const PIGGY_BANK_2 = GiPiggyBank;
export const PERSON_2 = GiPerson;

// CLEANING & HOUSEHOLD
export const BROOM_2 = GiBroom;
export const DRYER = TbWashDry;
export const CLOTHESLINE = GiClothesline;
export const TRASH_2 = TbTrashX;
export const DUSTER = GiFeather;
export const PLUNGER = GiPlunger;
export const PEST = TbBugOff;
export const TIMER_2 = TbClockHour4;
export const MICROWAVE_2 = TbMicrowave;
export const TOASTER = GiToaster;
export const LIGHT_SWITCH = TbToggleLeft;
export const PLANT_WATER = TbPlant2;
export const BUBBLES = GiBubbles;
export const CLOTHESPIN = GiClothespin;
export const DUST_CLOUD = GiDustCloud;
export const BUG_NET = GiBugNet;
export const SPRAY_3 = GiSpray;
export const TRASH_CAN_2 = GiTrashCan;
export const VACUUM_3 = GiVacuumCleaner;
export const WASHING_MACHINE_2 = GiWashingMachine;
export const SHOWER_3 = GiShower;
export const WINDOW_3 = GiWindow;
export const LAUNDRY_BASKET = GiBasket;
export const BED_LAMP = GiBedLamp;
export const HANGER_3 = GiHanger;
export const RECYCLE_3 = GiRecycle;
export const TUMBLE_DRY = TbWashTumbleDry;
export const HAND_WASH = TbWashHand;
export const WASH_ECO = TbWashEco;
export const DRY_FLAT = TbWashDryFlat;
export * from './iconsTrades'; // KPR-1190, split out for the file-size ratchet
